module.exports = [
  {
    id: "2",
    word: "a avea nevoie"
  },
  {
    id: "63",
    word: "perete"
  },
  {
    id: "75",
    word: "Dumnezeu"
  },
  {
    id: "85",
    word: "pahar"
  },
  {
    id: "124",
    word: "gând"
  },
  {
    id: "134",
    word: "respirație"
  },
  {
    id: "151",
    word: "a deschide"
  },
  {
    id: "155",
    word: "a trăi"
  },
  {
    id: "184",
    word: "frizer"
  },
  {
    id: "203",
    word: "a se plimba"
  },
  {
    id: "209",
    word: "a vrea"
  },
  {
    id: "210",
    word: "a se întâmpla"
  },
  {
    id: "211",
    word: "scrum"
  },
  {
    id: "256",
    word: "a sta"
  },
  {
    id: "259",
    word: "a agăța"
  },
  {
    id: "301",
    word: "a durea"
  },
  {
    id: "306",
    word: "curajos"
  },
  {
    id: "316",
    word: "notiță"
  },
  {
    id: "351",
    word: "a plăcea"
  },
  {
    id: "355",
    word: "trebuie să"
  },
  {
    id: "430",
    word: "cântăreț"
  },
  {
    id: "458",
    word: "a-și cere scuze"
  },
  {
    id: "460",
    word: "a se căsători"
  },
  {
    id: "490",
    word: "inundație"
  },
  {
    id: "557",
    word: "a se îndrăgosti"
  },
  {
    id: "559",
    word: "în străinătate"
  },
  {
    id: "577",
    word: "mai bun"
  },
  {
    id: "578",
    word: "aplicație"
  },
  {
    id: "600",
    word: "televizor"
  },
  {
    id: "684",
    word: "sfert"
  },
  {
    id: "709",
    word: "a-și imagina"
  },
  {
    id: "742",
    word: "om de zăpadă"
  },
  {
    id: "756",
    word: "secretară"
  },
  {
    id: "757",
    word: "sport"
  },
  {
    id: "767",
    word: "al doilea"
  },
  {
    id: "780",
    word: "farmacist"
  },
  {
    id: "787",
    word: "al treilea"
  },
  {
    id: "800",
    word: "autostradă"
  },
  {
    id: "811",
    word: "acadea"
  },
  {
    id: "837",
    word: "crevete"
  },
  {
    id: "940",
    word: "anvelopă"
  },
  {
    id: "978",
    word: "căprioară"
  },
  {
    id: "979",
    word: "scoică"
  },
  {
    id: "995",
    word: "dragon"
  },
  {
    id: "1001",
    word: "economist"
  },
  {
    id: "1002",
    word: "a asculta"
  },
  {
    id: "1003",
    word: "a cere"
  },
  {
    id: "1005",
    word: "a momi"
  },
  {
    id: "1006",
    word: "a fugi"
  },
  {
    id: "1008",
    word: "a fi stânjenit"
  },
  {
    id: "1009",
    word: "a se uita"
  },
  {
    id: "1010",
    word: "a reprezenta"
  },
  {
    id: "1011",
    word: "linie"
  },
  {
    id: "1013",
    word: "stomac"
  },
  {
    id: "1015",
    word: "a schimba"
  },
  {
    id: "1016",
    word: "electrician"
  },
  {
    id: "1017",
    word: "balansoar"
  },
  {
    id: "1018",
    word: "a se apăra"
  },
  {
    id: "1020",
    word: "midie"
  },
  {
    id: "1021",
    word: "comunitate"
  },
  {
    id: "1022",
    word: "punct"
  },
  {
    id: "1023",
    word: "bandă adezivă"
  },
  {
    id: "1024",
    word: "cuplu"
  },
  {
    id: "1025",
    word: "bețișor de ureche"
  },
  {
    id: "1026",
    word: "duzină"
  },
  {
    id: "1027",
    word: "videoclip"
  },
  {
    id: "1028",
    word: "coș"
  },
  {
    id: "1030",
    word: "încercare"
  },
  {
    id: "1033",
    word: "raport"
  },
  {
    id: "1035",
    word: "mal"
  },
  {
    id: "1036",
    word: "general"
  },
  {
    id: "1037",
    word: "rădăcină"
  },
  {
    id: "1038",
    word: "al paisprezecelea"
  },
  {
    id: "1039",
    word: "îngrijorare"
  },
  {
    id: "1040",
    word: "presă"
  },
  {
    id: "1041",
    word: "șobolan"
  },
  {
    id: "1042",
    word: "societate"
  },
  {
    id: "1043",
    word: "sens"
  },
  {
    id: "1044",
    word: "narator"
  },
  {
    id: "1045",
    word: "comandă"
  },
  {
    id: "1046",
    word: "secundă"
  },
  {
    id: "1047",
    word: "model"
  },
  {
    id: "1048",
    word: "tanc"
  },
  {
    id: "1049",
    word: "al cincisprezecelea"
  },
  {
    id: "1050",
    word: "ventilator"
  },
  {
    id: "1051",
    word: "al șaptesprezecelea"
  },
  {
    id: "1052",
    word: "plantă"
  },
  {
    id: "1054",
    word: "al nouăsprezecelea"
  },
  {
    id: "1055",
    word: "a învinge"
  },
  {
    id: "1056",
    word: "al douăzecilea"
  },
  {
    id: "1057",
    word: "surf"
  },
  {
    id: "1059",
    word: "cartier"
  },
  {
    id: "1060",
    word: "navigare"
  },
  {
    id: "1061",
    word: "fundal"
  },
  {
    id: "1062",
    word: "canotaj"
  },
  {
    id: "1063",
    word: "apartament"
  },
  {
    id: "1065",
    word: "cufăr"
  },
  {
    id: "1067",
    word: "echipament"
  },
  {
    id: "1068",
    word: "mai"
  },
  {
    id: "1070",
    word: "gimnastică"
  },
  {
    id: "1071",
    word: "vârf"
  },
  {
    id: "1074",
    word: "date"
  },
  {
    id: "1075",
    word: "conexiune"
  },
  {
    id: "1076",
    word: "truc"
  },
  {
    id: "1078",
    word: "perioadă"
  },
  {
    id: "1079",
    word: "a schimba vitezele"
  },
  {
    id: "1080",
    word: "maieu"
  },
  {
    id: "1081",
    word: "bomboană"
  },
  {
    id: "1082",
    word: "coardă"
  },
  {
    id: "1084",
    word: "baseball"
  },
  {
    id: "1085",
    word: "securitate"
  },
  {
    id: "1086",
    word: "înălțime"
  },
  {
    id: "1088",
    word: "hochei pe gheață"
  },
  {
    id: "1089",
    word: "mină de teren"
  },
  {
    id: "1091",
    word: "reacție"
  },
  {
    id: "1092",
    word: "sursă"
  },
  {
    id: "1093",
    word: "a dubla"
  },
  {
    id: "1094",
    word: "pistol"
  },
  {
    id: "1096",
    word: "a campa"
  },
  {
    id: "1097",
    word: "promisiune"
  },
  {
    id: "1098",
    word: "arc"
  },
  {
    id: "1099",
    word: "al șaisprezecelea"
  },
  {
    id: "1101",
    word: "a menționa"
  },
  {
    id: "1102",
    word: "a se lupta"
  },
  {
    id: "1104",
    word: "a ridica"
  },
  {
    id: "1105",
    word: "bowling"
  },
  {
    id: "1106",
    word: "a tricota"
  },
  {
    id: "1107",
    word: "a juca cărți"
  },
  {
    id: "1108",
    word: "a alege"
  },
  {
    id: "1109",
    word: "a ține"
  },
  {
    id: "1110",
    word: "a străluci"
  },
  {
    id: "1111",
    word: "mașină de bani"
  },
  {
    id: "1113",
    word: "box"
  },
  {
    id: "1114",
    word: "medicament"
  },
  {
    id: "1115",
    word: "pivniță"
  },
  {
    id: "1116",
    word: "wrestling"
  },
  {
    id: "1117",
    word: "șapcă"
  },
  {
    id: "1118",
    word: "fier"
  },
  {
    id: "1120",
    word: "semnal"
  },
  {
    id: "1121",
    word: "servitor"
  },
  {
    id: "1122",
    word: "șoaptă"
  },
  {
    id: "1123",
    word: "îndoială"
  },
  {
    id: "1125",
    word: "luptă"
  },
  {
    id: "1127",
    word: "membru"
  },
  {
    id: "1128",
    word: "cursă"
  },
  {
    id: "1130",
    word: "a scădea"
  },
  {
    id: "1131",
    word: "guler"
  },
  {
    id: "1132",
    word: "corn"
  },
  {
    id: "1133",
    word: "stejar"
  },
  {
    id: "1134",
    word: "gleznă"
  },
  {
    id: "1135",
    word: "păpușă"
  },
  {
    id: "1136",
    word: "cățărare"
  },
  {
    id: "1139",
    word: "mândrie"
  },
  {
    id: "1140",
    word: "tinerețe"
  },
  {
    id: "1141",
    word: "a sufla"
  },
  {
    id: "1142",
    word: "cercetare"
  },
  {
    id: "1143",
    word: "a acoperi"
  },
  {
    id: "1144",
    word: "sarcină"
  },
  {
    id: "1145",
    word: "aprobare"
  },
  {
    id: "1146",
    word: "șerif"
  },
  {
    id: "1147",
    word: "a condimenta"
  },
  {
    id: "1148",
    word: "cip"
  },
  {
    id: "1149",
    word: "teorie"
  },
  {
    id: "1150",
    word: "a face cunoștință"
  },
  {
    id: "1151",
    word: "camping"
  },
  {
    id: "1153",
    word: "a dormi prea mult"
  },
  {
    id: "1155",
    word: "spectacol"
  },
  {
    id: "1158",
    word: "a răzbuna"
  },
  {
    id: "1159",
    word: "a zăbovi"
  },
  {
    id: "1160",
    word: "fan"
  },
  {
    id: "1161",
    word: "colecție"
  },
  {
    id: "1162",
    word: "cruce"
  },
  {
    id: "1163",
    word: "pin"
  },
  {
    id: "1164",
    word: "generație"
  },
  {
    id: "1165",
    word: "autoritate"
  },
  {
    id: "1166",
    word: "handbal"
  },
  {
    id: "1167",
    word: "călătorie"
  },
  {
    id: "1168",
    word: "perlă"
  },
  {
    id: "1169",
    word: "ulei"
  },
  {
    id: "1170",
    word: "ucigaș"
  },
  {
    id: "1171",
    word: "instrument"
  },
  {
    id: "1173",
    word: "vizită"
  },
  {
    id: "1174",
    word: "cerere"
  },
  {
    id: "1175",
    word: "buric"
  },
  {
    id: "1176",
    word: "stâncă"
  },
  {
    id: "1179",
    word: "pacient"
  },
  {
    id: "1180",
    word: "cușcă"
  },
  {
    id: "1181",
    word: "a sforăi"
  },
  {
    id: "1182",
    word: "coastă"
  },
  {
    id: "1183",
    word: "dulap"
  },
  {
    id: "1184",
    word: "înțeles"
  },
  {
    id: "1186",
    word: "valiză"
  },
  {
    id: "1187",
    word: "operațiune"
  },
  {
    id: "1188",
    word: "camera copiilor"
  },
  {
    id: "1189",
    word: "rol"
  },
  {
    id: "1190",
    word: "versiune"
  },
  {
    id: "1191",
    word: "prizonier"
  },
  {
    id: "1192",
    word: "ghilimele"
  },
  {
    id: "1194",
    word: "mănușă de gătit"
  },
  {
    id: "1195",
    word: "intestinul gros"
  },
  {
    id: "1196",
    word: "cratimă"
  },
  {
    id: "1197",
    word: "puncte de suspensie"
  },
  {
    id: "1198",
    word: "pol"
  },
  {
    id: "1199",
    word: "relație"
  },
  {
    id: "1200",
    word: "coș de gunoi"
  },
  {
    id: "1201",
    word: "splină"
  },
  {
    id: "1202",
    word: "a seduce"
  },
  {
    id: "1205",
    word: "a număra"
  },
  {
    id: "1206",
    word: "subraț"
  },
  {
    id: "1207",
    word: "fum"
  },
  {
    id: "1208",
    word: "a lătra"
  },
  {
    id: "1209",
    word: "a suferi"
  },
  {
    id: "1210",
    word: "a evada"
  },
  {
    id: "1211",
    word: "pasiune"
  },
  {
    id: "1212",
    word: "activitate"
  },
  {
    id: "1213",
    word: "atac"
  },
  {
    id: "1216",
    word: "a vira"
  },
  {
    id: "1217",
    word: "cheie"
  },
  {
    id: "1218",
    word: "însoțitor"
  },
  {
    id: "1220",
    word: "viespe"
  },
  {
    id: "1221",
    word: "zona inghinală"
  },
  {
    id: "1222",
    word: "a onora"
  },
  {
    id: "1224",
    word: "partener"
  },
  {
    id: "1226",
    word: "monitor"
  },
  {
    id: "1227",
    word: "maghiară"
  },
  {
    id: "1228",
    word: "respect"
  },
  {
    id: "1229",
    word: "extaz"
  },
  {
    id: "1230",
    word: "hol"
  },
  {
    id: "1233",
    word: "sector"
  },
  {
    id: "1234",
    word: "subiect"
  },
  {
    id: "1235",
    word: "cod"
  },
  {
    id: "1236",
    word: "capitol"
  },
  {
    id: "1237",
    word: "reflecție"
  },
  {
    id: "1238",
    word: "Ecuator"
  },
  {
    id: "1239",
    word: "anatomie"
  },
  {
    id: "1241",
    word: "uniformă"
  },
  {
    id: "1246",
    word: "paletă"
  },
  {
    id: "1247",
    word: "sumă"
  },
  {
    id: "1248",
    word: "nerv"
  },
  {
    id: "1249",
    word: "florar"
  },
  {
    id: "1250",
    word: "roman"
  },
  {
    id: "1251",
    word: "gât"
  },
  {
    id: "1252",
    word: "a geme"
  },
  {
    id: "1254",
    word: "a se înțelege"
  },
  {
    id: "1255",
    word: "a oferi"
  },
  {
    id: "1257",
    word: "a pulveriza"
  },
  {
    id: "1260",
    word: "nasture"
  },
  {
    id: "1262",
    word: "a imprima"
  },
  {
    id: "1263",
    word: "vopsea"
  },
  {
    id: "1265",
    word: "a contraataca"
  },
  {
    id: "1266",
    word: "chiuvetă"
  },
  {
    id: "1267",
    word: "credit"
  },
  {
    id: "1269",
    word: "diavol"
  },
  {
    id: "1270",
    word: "amenințare"
  },
  {
    id: "1273",
    word: "briză"
  },
  {
    id: "1274",
    word: "tigaie"
  },
  {
    id: "1275",
    word: "a da bacșiș"
  },
  {
    id: "1276",
    word: "titlu"
  },
  {
    id: "1277",
    word: "liniștit"
  },
  {
    id: "1278",
    word: "dizgrație"
  },
  {
    id: "1279",
    word: "ac"
  },
  {
    id: "1280",
    word: "plămân"
  },
  {
    id: "1281",
    word: "războinic"
  },
  {
    id: "1282",
    word: "circumstanță"
  },
  {
    id: "1283",
    word: "studio"
  },
  {
    id: "1284",
    word: "panică"
  },
  {
    id: "1286",
    word: "fermier"
  },
  {
    id: "1287",
    word: "accent"
  },
  {
    id: "1288",
    word: "bombă"
  },
  {
    id: "1289",
    word: "Serbia"
  },
  {
    id: "1290",
    word: "abilitate"
  },
  {
    id: "1291",
    word: "anotimp"
  },
  {
    id: "1292",
    word: "câștigător"
  },
  {
    id: "1293",
    word: "pană"
  },
  {
    id: "1296",
    word: "comportament"
  },
  {
    id: "1297",
    word: "gras"
  },
  {
    id: "1298",
    word: "sclav"
  },
  {
    id: "1300",
    word: "butoi"
  },
  {
    id: "1301",
    word: "a tortura"
  },
  {
    id: "1302",
    word: "a raporta"
  },
  {
    id: "1303",
    word: "a prăji"
  },
  {
    id: "1305",
    word: "a întâmpina"
  },
  {
    id: "1306",
    word: "Republica Cehă"
  },
  {
    id: "1307",
    word: "sparanghel"
  },
  {
    id: "1309",
    word: "a deține"
  },
  {
    id: "1311",
    word: "căldură"
  },
  {
    id: "1312",
    word: "impresie"
  },
  {
    id: "1314",
    word: "fraier"
  },
  {
    id: "1315",
    word: "misiune"
  },
  {
    id: "1316",
    word: "ceață"
  },
  {
    id: "1317",
    word: "pierdere"
  },
  {
    id: "1318",
    word: "echilibru"
  },
  {
    id: "1319",
    word: "pânză de păianjen"
  },
  {
    id: "1320",
    word: "termen"
  },
  {
    id: "1321",
    word: "lacăt"
  },
  {
    id: "1323",
    word: "baie"
  },
  {
    id: "1324",
    word: "realitate"
  },
  {
    id: "1325",
    word: "cadavru"
  },
  {
    id: "1326",
    word: "explicație"
  },
  {
    id: "1328",
    word: "ieșire"
  },
  {
    id: "1330",
    word: "aragaz"
  },
  {
    id: "1332",
    word: "american"
  },
  {
    id: "1333",
    word: "rubin"
  },
  {
    id: "1335",
    word: "groapă"
  },
  {
    id: "1336",
    word: "colonel"
  },
  {
    id: "1337",
    word: "doc"
  },
  {
    id: "1338",
    word: "pârâu"
  },
  {
    id: "1339",
    word: "sfat"
  },
  {
    id: "1340",
    word: "ramură"
  },
  {
    id: "1341",
    word: "tristețe"
  },
  {
    id: "1342",
    word: "apărare"
  },
  {
    id: "1343",
    word: "mușcătură"
  },
  {
    id: "1345",
    word: "favoare"
  },
  {
    id: "1346",
    word: "raft de bibliotecă"
  },
  {
    id: "1347",
    word: "confort"
  },
  {
    id: "1348",
    word: "decan"
  },
  {
    id: "1349",
    word: "valoare"
  },
  {
    id: "1351",
    word: "a ofta"
  },
  {
    id: "1352",
    word: "a înflori"
  },
  {
    id: "1355",
    word: "a divorța"
  },
  {
    id: "1356",
    word: "a crește"
  },
  {
    id: "1357",
    word: "a rezolva"
  },
  {
    id: "1359",
    word: "a se feri"
  },
  {
    id: "1360",
    word: "a prăji"
  },
  {
    id: "1361",
    word: "proprietate"
  },
  {
    id: "1362",
    word: "echipă"
  },
  {
    id: "1363",
    word: "a arde"
  },
  {
    id: "1364",
    word: "a-i fi sete"
  },
  {
    id: "1365",
    word: "praz"
  },
  {
    id: "1368",
    word: "sac"
  },
  {
    id: "1369",
    word: "demon"
  },
  {
    id: "1370",
    word: "a unge"
  },
  {
    id: "1372",
    word: "responsabilitate"
  },
  {
    id: "1373",
    word: "pensulă"
  },
  {
    id: "1374",
    word: "rută"
  },
  {
    id: "1375",
    word: "a mișca"
  },
  {
    id: "1376",
    word: "bețigașe"
  },
  {
    id: "1378",
    word: "sfânt"
  },
  {
    id: "1379",
    word: "Statele Unite ale Americii"
  },
  {
    id: "1380",
    word: "țintă"
  },
  {
    id: "1381",
    word: "portocală"
  },
  {
    id: "1382",
    word: "cremă"
  },
  {
    id: "1384",
    word: "comandant"
  },
  {
    id: "1385",
    word: "cârlig"
  },
  {
    id: "1387",
    word: "antrenament"
  },
  {
    id: "1388",
    word: "căutare"
  },
  {
    id: "1393",
    word: "ficțiune"
  },
  {
    id: "1394",
    word: "lac"
  },
  {
    id: "1395",
    word: "stare de spirit"
  },
  {
    id: "1396",
    word: "design"
  },
  {
    id: "1398",
    word: "lamă"
  },
  {
    id: "1399",
    word: "soacră"
  },
  {
    id: "1400",
    word: "comentariu"
  },
  {
    id: "1401",
    word: "a porni"
  },
  {
    id: "1402",
    word: "al nouălea"
  },
  {
    id: "1404",
    word: "a ajunge"
  },
  {
    id: "1406",
    word: "a irita"
  },
  {
    id: "1407",
    word: "a vâna"
  },
  {
    id: "1408",
    word: "a fi situat"
  },
  {
    id: "1410",
    word: "grad"
  },
  {
    id: "1411",
    word: "a suna"
  },
  {
    id: "1412",
    word: "mâncare"
  },
  {
    id: "1413",
    word: "scară"
  },
  {
    id: "1414",
    word: "curbă"
  },
  {
    id: "1415",
    word: "volum"
  },
  {
    id: "1416",
    word: "Azerbaijan"
  },
  {
    id: "1418",
    word: "existență"
  },
  {
    id: "1419",
    word: "urmă"
  },
  {
    id: "1420",
    word: "boală"
  },
  {
    id: "1422",
    word: "reporter"
  },
  {
    id: "1423",
    word: "anghinare"
  },
  {
    id: "1425",
    word: "picătură"
  },
  {
    id: "1426",
    word: "pâlnie"
  },
  {
    id: "1429",
    word: "sfeclă roșie"
  },
  {
    id: "1430",
    word: "talent"
  },
  {
    id: "1431",
    word: "întunecat"
  },
  {
    id: "1432",
    word: "copie"
  },
  {
    id: "1433",
    word: "ridiche"
  },
  {
    id: "1434",
    word: "capac"
  },
  {
    id: "1435",
    word: "indiciu"
  },
  {
    id: "1436",
    word: "a face autostopul"
  },
  {
    id: "1437",
    word: "hamac"
  },
  {
    id: "1439",
    word: "cartof dulce"
  },
  {
    id: "1440",
    word: "abordare"
  },
  {
    id: "1441",
    word: "chimen"
  },
  {
    id: "1442",
    word: "șofran"
  },
  {
    id: "1443",
    word: "canal"
  },
  {
    id: "1444",
    word: "rozmarin"
  },
  {
    id: "1446",
    word: "șoim"
  },
  {
    id: "1447",
    word: "cimbru"
  },
  {
    id: "1451",
    word: "a uni"
  },
  {
    id: "1452",
    word: "ananas"
  },
  {
    id: "1453",
    word: "a cita"
  },
  {
    id: "1455",
    word: "smochină"
  },
  {
    id: "1456",
    word: "a identifica"
  },
  {
    id: "1457",
    word: "a comanda"
  },
  {
    id: "1458",
    word: "a topi"
  },
  {
    id: "1459",
    word: "a jigni"
  },
  {
    id: "1460",
    word: "a descoperi"
  },
  {
    id: "1461",
    word: "varză"
  },
  {
    id: "1462",
    word: "vacanță"
  },
  {
    id: "1463",
    word: "plin"
  },
  {
    id: "1465",
    word: "daune"
  },
  {
    id: "1466",
    word: "instrument"
  },
  {
    id: "1467",
    word: "mătase"
  },
  {
    id: "1468",
    word: "strat"
  },
  {
    id: "1469",
    word: "bandă"
  },
  {
    id: "1470",
    word: "gunoi"
  },
  {
    id: "1471",
    word: "coastă"
  },
  {
    id: "1472",
    word: "caiet"
  },
  {
    id: "1473",
    word: "fulg de zăpadă"
  },
  {
    id: "1474",
    word: "ofertă"
  },
  {
    id: "1475",
    word: "desen"
  },
  {
    id: "1476",
    word: "declarație"
  },
  {
    id: "1477",
    word: "inteligență"
  },
  {
    id: "1478",
    word: "scuză"
  },
  {
    id: "1479",
    word: "aterizare"
  },
  {
    id: "1480",
    word: "drept de autor"
  },
  {
    id: "1481",
    word: "băț"
  },
  {
    id: "1482",
    word: "fantezie"
  },
  {
    id: "1483",
    word: "curiozitate"
  },
  {
    id: "1484",
    word: "zgomotos"
  },
  {
    id: "1485",
    word: "graniță"
  },
  {
    id: "1486",
    word: "viu"
  },
  {
    id: "1492",
    word: "medie"
  },
  {
    id: "1495",
    word: "șină"
  },
  {
    id: "1496",
    word: "tufă"
  },
  {
    id: "1497",
    word: "curaj"
  },
  {
    id: "1498",
    word: "sosire"
  },
  {
    id: "1499",
    word: "dorință"
  },
  {
    id: "1501",
    word: "a curge"
  },
  {
    id: "1505",
    word: "a distruge"
  },
  {
    id: "1506",
    word: "a îndrăzni"
  },
  {
    id: "1507",
    word: "a reuși"
  },
  {
    id: "1508",
    word: "a tremura"
  },
  {
    id: "1509",
    word: "a comanda"
  },
  {
    id: "1510",
    word: "a hrăni"
  },
  {
    id: "1511",
    word: "a sacrifica"
  },
  {
    id: "1512",
    word: "taur"
  },
  {
    id: "1513",
    word: "sămânță"
  },
  {
    id: "1514",
    word: "progres"
  },
  {
    id: "1516",
    word: "pantaloni scurți"
  },
  {
    id: "1517",
    word: "cetățean"
  },
  {
    id: "1520",
    word: "răbdare"
  },
  {
    id: "1521",
    word: "liliac"
  },
  {
    id: "1522",
    word: "navă spațială"
  },
  {
    id: "1523",
    word: "rutină"
  },
  {
    id: "1524",
    word: "explozie"
  },
  {
    id: "1525",
    word: "conținut"
  },
  {
    id: "1526",
    word: "om de știință"
  },
  {
    id: "1528",
    word: "păcat"
  },
  {
    id: "1529",
    word: "faimos"
  },
  {
    id: "1530",
    word: "confuzie"
  },
  {
    id: "1535",
    word: "lanternă"
  },
  {
    id: "1536",
    word: "internet"
  },
  {
    id: "1537",
    word: "marinar"
  },
  {
    id: "1538",
    word: "atitudine"
  },
  {
    id: "1544",
    word: "evadare"
  },
  {
    id: "1545",
    word: "instrucțiune"
  },
  {
    id: "1546",
    word: "material"
  },
  {
    id: "1547",
    word: "marmură"
  },
  {
    id: "1548",
    word: "de gen feminin"
  },
  {
    id: "1549",
    word: "amurg"
  },
  {
    id: "1550",
    word: "cabană"
  },
  {
    id: "1553",
    word: "a lăsa"
  },
  {
    id: "1556",
    word: "a trișa"
  },
  {
    id: "1559",
    word: "a dedica"
  },
  {
    id: "1561",
    word: "maimuță"
  },
  {
    id: "1562",
    word: "machiaj"
  },
  {
    id: "1564",
    word: "bluză"
  },
  {
    id: "1565",
    word: "ritm"
  },
  {
    id: "1566",
    word: "abur"
  },
  {
    id: "1569",
    word: "pix"
  },
  {
    id: "1570",
    word: "speriat"
  },
  {
    id: "1571",
    word: "steag"
  },
  {
    id: "1572",
    word: "antrenor"
  },
  {
    id: "1573",
    word: "leagăn"
  },
  {
    id: "1574",
    word: "difuzor"
  },
  {
    id: "1575",
    word: "șurub"
  },
  {
    id: "1576",
    word: "grăsime"
  },
  {
    id: "1580",
    word: "pauză"
  },
  {
    id: "1582",
    word: "natural"
  },
  {
    id: "1584",
    word: "furculiță"
  },
  {
    id: "1585",
    word: "rău"
  },
  {
    id: "1586",
    word: "cameristă"
  },
  {
    id: "1587",
    word: "rudă"
  },
  {
    id: "1588",
    word: "vrăjitoare"
  },
  {
    id: "1592",
    word: "cititor"
  },
  {
    id: "1594",
    word: "plăcintă"
  },
  {
    id: "1598",
    word: "adolescent"
  },
  {
    id: "1599",
    word: "o sută de mii"
  },
  {
    id: "1600",
    word: "chelneriță"
  },
  {
    id: "1601",
    word: "a pieptăna"
  },
  {
    id: "1603",
    word: "a fierbe"
  },
  {
    id: "1604",
    word: "a accepta"
  },
  {
    id: "1607",
    word: "a ajunge"
  },
  {
    id: "1612",
    word: "zvon"
  },
  {
    id: "1613",
    word: "gravitație"
  },
  {
    id: "1615",
    word: "gest"
  },
  {
    id: "1617",
    word: "coloană vertebrală"
  },
  {
    id: "1618",
    word: "dezordonat"
  },
  {
    id: "1619",
    word: "adâncime"
  },
  {
    id: "1620",
    word: "rază"
  },
  {
    id: "1622",
    word: "Biblie"
  },
  {
    id: "1624",
    word: "portofel"
  },
  {
    id: "1625",
    word: "junglă"
  },
  {
    id: "1626",
    word: "fabrică"
  },
  {
    id: "1627",
    word: "indian"
  },
  {
    id: "1628",
    word: "trecut"
  },
  {
    id: "1629",
    word: "orez"
  },
  {
    id: "1630",
    word: "nod"
  },
  {
    id: "1632",
    word: "coleg"
  },
  {
    id: "1633",
    word: "deschizător de conserve"
  },
  {
    id: "1635",
    word: "motel"
  },
  {
    id: "1638",
    word: "discuție"
  },
  {
    id: "1639",
    word: "atmosferă"
  },
  {
    id: "1640",
    word: "performanță"
  },
  {
    id: "1642",
    word: "text"
  },
  {
    id: "1643",
    word: "calitate de membru"
  },
  {
    id: "1644",
    word: "prânz"
  },
  {
    id: "1645",
    word: "venă"
  },
  {
    id: "1646",
    word: "drumeție"
  },
  {
    id: "1649",
    word: "cancer"
  },
  {
    id: "1650",
    word: "a turna"
  },
  {
    id: "1651",
    word: "a întrerupe"
  },
  {
    id: "1652",
    word: "a răpi"
  },
  {
    id: "1653",
    word: "a usca"
  },
  {
    id: "1654",
    word: "dulap de bucătărie"
  },
  {
    id: "1655",
    word: "a găti"
  },
  {
    id: "1656",
    word: "a îmblânzi"
  },
  {
    id: "1657",
    word: "grădinar"
  },
  {
    id: "1659",
    word: "arte marțiale"
  },
  {
    id: "1660",
    word: "a striga"
  },
  {
    id: "1661",
    word: "divorț"
  },
  {
    id: "1662",
    word: "puls"
  },
  {
    id: "1663",
    word: "absență"
  },
  {
    id: "1664",
    word: "violență"
  },
  {
    id: "1665",
    word: "umor"
  },
  {
    id: "1666",
    word: "gaz"
  },
  {
    id: "1668",
    word: "comoară"
  },
  {
    id: "1669",
    word: "unt"
  },
  {
    id: "1670",
    word: "întrerupător"
  },
  {
    id: "1671",
    word: "trabuc"
  },
  {
    id: "1672",
    word: "pânză"
  },
  {
    id: "1674",
    word: "plin"
  },
  {
    id: "1676",
    word: "actor"
  },
  {
    id: "1678",
    word: "acord"
  },
  {
    id: "1680",
    word: "gazdă"
  },
  {
    id: "1681",
    word: "fundă"
  },
  {
    id: "1682",
    word: "fular"
  },
  {
    id: "1684",
    word: "sirenă"
  },
  {
    id: "1685",
    word: "săgeată"
  },
  {
    id: "1686",
    word: "temperatură"
  },
  {
    id: "1687",
    word: "tehnologie"
  },
  {
    id: "1688",
    word: "permisiune"
  },
  {
    id: "1690",
    word: "gheară"
  },
  {
    id: "1691",
    word: "cowboy"
  },
  {
    id: "1692",
    word: "agenție"
  },
  {
    id: "1693",
    word: "construcție"
  },
  {
    id: "1694",
    word: "poștaș"
  },
  {
    id: "1695",
    word: "străin"
  },
  {
    id: "1696",
    word: "focă"
  },
  {
    id: "1697",
    word: "elicopter"
  },
  {
    id: "1698",
    word: "capcană"
  },
  {
    id: "1700",
    word: "spațiu"
  },
  {
    id: "1702",
    word: "a glumi"
  },
  {
    id: "1705",
    word: "a ciocăni"
  },
  {
    id: "1706",
    word: "a răci"
  },
  {
    id: "1707",
    word: "a peria"
  },
  {
    id: "1708",
    word: "a mesteca"
  },
  {
    id: "1709",
    word: "a trezi"
  },
  {
    id: "1710",
    word: "a încărca"
  },
  {
    id: "1711",
    word: "animal de companie"
  },
  {
    id: "1712",
    word: "educație"
  },
  {
    id: "1713",
    word: "cumpărături"
  },
  {
    id: "1714",
    word: "mătreață"
  },
  {
    id: "1715",
    word: "ar trebui"
  },
  {
    id: "1716",
    word: "ascuțit"
  },
  {
    id: "1717",
    word: "duce"
  },
  {
    id: "1718",
    word: "pistol"
  },
  {
    id: "1719",
    word: "părere"
  },
  {
    id: "1721",
    word: "ceremonie"
  },
  {
    id: "1722",
    word: "lingură"
  },
  {
    id: "1723",
    word: "cadă"
  },
  {
    id: "1724",
    word: "greu"
  },
  {
    id: "1726",
    word: "incident"
  },
  {
    id: "1727",
    word: "accident"
  },
  {
    id: "1729",
    word: "cert"
  },
  {
    id: "1730",
    word: "incert"
  },
  {
    id: "1731",
    word: "râs"
  },
  {
    id: "1733",
    word: "oaie"
  },
  {
    id: "1734",
    word: "inginer"
  },
  {
    id: "1735",
    word: "papion"
  },
  {
    id: "1736",
    word: "miros"
  },
  {
    id: "1737",
    word: "afacere"
  },
  {
    id: "1738",
    word: "invitație"
  },
  {
    id: "1742",
    word: "tratament"
  },
  {
    id: "1743",
    word: "înțelepciune"
  },
  {
    id: "1744",
    word: "tocit"
  },
  {
    id: "1745",
    word: "element"
  },
  {
    id: "1746",
    word: "gigant"
  },
  {
    id: "1747",
    word: "șervețel"
  },
  {
    id: "1749",
    word: "opțiune"
  },
  {
    id: "1750",
    word: "nesportiv"
  },
  {
    id: "1752",
    word: "diseară"
  },
  {
    id: "1753",
    word: "a scuipa"
  },
  {
    id: "1755",
    word: "a cunoaște"
  },
  {
    id: "1756",
    word: "a respira"
  },
  {
    id: "1757",
    word: "mișcare"
  },
  {
    id: "1758",
    word: "încurcătură de limbă"
  },
  {
    id: "1759",
    word: "a urla"
  },
  {
    id: "1762",
    word: "lăcătuș"
  },
  {
    id: "1765",
    word: "punct"
  },
  {
    id: "1767",
    word: "ciudat"
  },
  {
    id: "1768",
    word: "canapea"
  },
  {
    id: "1769",
    word: "exercițiu"
  },
  {
    id: "1770",
    word: "văduvă"
  },
  {
    id: "1771",
    word: "cioară"
  },
  {
    id: "1773",
    word: "sinucidere"
  },
  {
    id: "1774",
    word: "plăcut"
  },
  {
    id: "1778",
    word: "tunet"
  },
  {
    id: "1780",
    word: "whiskey"
  },
  {
    id: "1782",
    word: "primar"
  },
  {
    id: "1783",
    word: "irațional"
  },
  {
    id: "1785",
    word: "reputație"
  },
  {
    id: "1786",
    word: "sensibil"
  },
  {
    id: "1789",
    word: "cimitir"
  },
  {
    id: "1790",
    word: "telecomandă"
  },
  {
    id: "1791",
    word: "instinct"
  },
  {
    id: "1794",
    word: "cuib"
  },
  {
    id: "1795",
    word: "limită"
  },
  {
    id: "1796",
    word: "german"
  },
  {
    id: "1797",
    word: "călugăr"
  },
  {
    id: "1798",
    word: "vierme"
  },
  {
    id: "1799",
    word: "a premia"
  },
  {
    id: "1800",
    word: "tristețe"
  },
  {
    id: "1803",
    word: "a încălzi"
  },
  {
    id: "1804",
    word: "a amesteca"
  },
  {
    id: "1805",
    word: "a mirosi"
  },
  {
    id: "1807",
    word: "a preda"
  },
  {
    id: "1809",
    word: "a-i fi frică"
  },
  {
    id: "1810",
    word: "a întinde"
  },
  {
    id: "1811",
    word: "împușcătură"
  },
  {
    id: "1812",
    word: "dansator"
  },
  {
    id: "1813",
    word: "asigurare"
  },
  {
    id: "1815",
    word: "saltea"
  },
  {
    id: "1817",
    word: "clinică"
  },
  {
    id: "1818",
    word: "anunț"
  },
  {
    id: "1819",
    word: "cană"
  },
  {
    id: "1820",
    word: "vertical"
  },
  {
    id: "1821",
    word: "suport pentru pantofi"
  },
  {
    id: "1822",
    word: "dezastru"
  },
  {
    id: "1823",
    word: "gresie"
  },
  {
    id: "1824",
    word: "receptor"
  },
  {
    id: "1827",
    word: "trupă"
  },
  {
    id: "1828",
    word: "poală"
  },
  {
    id: "1829",
    word: "prietenie"
  },
  {
    id: "1836",
    word: "lână"
  },
  {
    id: "1838",
    word: "ministru"
  },
  {
    id: "1839",
    word: "intrare"
  },
  {
    id: "1840",
    word: "hoț"
  },
  {
    id: "1841",
    word: "servietă"
  },
  {
    id: "1843",
    word: "amprentă"
  },
  {
    id: "1844",
    word: "marină"
  },
  {
    id: "1845",
    word: "insectă"
  },
  {
    id: "1850",
    word: "genă"
  },
  {
    id: "1851",
    word: "a vindeca"
  },
  {
    id: "1854",
    word: "a umple"
  },
  {
    id: "1855",
    word: "a retrage"
  },
  {
    id: "1857",
    word: "a călări"
  },
  {
    id: "1858",
    word: "a costa"
  },
  {
    id: "1859",
    word: "a împrumuta"
  },
  {
    id: "1861",
    word: "situație"
  },
  {
    id: "1862",
    word: "parbriz"
  },
  {
    id: "1864",
    word: "singur"
  },
  {
    id: "1865",
    word: "ofițer"
  },
  {
    id: "1866",
    word: "furie"
  },
  {
    id: "1868",
    word: "satisfacție"
  },
  {
    id: "1872",
    word: "usturoi"
  },
  {
    id: "1874",
    word: "capitală"
  },
  {
    id: "1876",
    word: "labă"
  },
  {
    id: "1878",
    word: "cost"
  },
  {
    id: "1879",
    word: "schimbare"
  },
  {
    id: "1880",
    word: "vampir"
  },
  {
    id: "1881",
    word: "creatură"
  },
  {
    id: "1882",
    word: "identitate"
  },
  {
    id: "1884",
    word: "contor"
  },
  {
    id: "1886",
    word: "sufragerie"
  },
  {
    id: "1887",
    word: "port"
  },
  {
    id: "1888",
    word: "iubit"
  },
  {
    id: "1890",
    word: "trupă"
  },
  {
    id: "1891",
    word: "mură"
  },
  {
    id: "1892",
    word: "conopidă"
  },
  {
    id: "1893",
    word: "dezorientat"
  },
  {
    id: "1894",
    word: "taxă"
  },
  {
    id: "1896",
    word: "portret"
  },
  {
    id: "1897",
    word: "țesut"
  },
  {
    id: "1898",
    word: "credință"
  },
  {
    id: "1899",
    word: "a disprețui"
  },
  {
    id: "1901",
    word: "a tuși"
  },
  {
    id: "1902",
    word: "a căsca"
  },
  {
    id: "1907",
    word: "a transpira"
  },
  {
    id: "1908",
    word: "a calcula"
  },
  {
    id: "1909",
    word: "a da cu ciocanul"
  },
  {
    id: "1912",
    word: "palmă"
  },
  {
    id: "1913",
    word: "cavaler"
  },
  {
    id: "1914",
    word: "rang"
  },
  {
    id: "1916",
    word: "fântână"
  },
  {
    id: "1919",
    word: "scânteie"
  },
  {
    id: "1921",
    word: "șampanie"
  },
  {
    id: "1922",
    word: "sector"
  },
  {
    id: "1923",
    word: "protecție"
  },
  {
    id: "1924",
    word: "verdict"
  },
  {
    id: "1925",
    word: "simpatie"
  },
  {
    id: "1926",
    word: "pragul ușii"
  },
  {
    id: "1927",
    word: "impact"
  },
  {
    id: "1928",
    word: "dezamăgire"
  },
  {
    id: "1930",
    word: "conștiință"
  },
  {
    id: "1931",
    word: "batistă"
  },
  {
    id: "1932",
    word: "noptieră"
  },
  {
    id: "1933",
    word: "interes"
  },
  {
    id: "1934",
    word: "rețea"
  },
  {
    id: "1935",
    word: "afirmație"
  },
  {
    id: "1936",
    word: "călugăriță"
  },
  {
    id: "1937",
    word: "coroană"
  },
  {
    id: "1939",
    word: "licență"
  },
  {
    id: "1940",
    word: "milă"
  },
  {
    id: "1941",
    word: "presiune"
  },
  {
    id: "1942",
    word: "haos"
  },
  {
    id: "1943",
    word: "febră"
  },
  {
    id: "1944",
    word: "dulap"
  },
  {
    id: "1947",
    word: "ascuțitoare"
  },
  {
    id: "1948",
    word: "tobă"
  },
  {
    id: "1951",
    word: "a informa"
  },
  {
    id: "1953",
    word: "a crește"
  },
  {
    id: "1955",
    word: "colesterol"
  },
  {
    id: "1956",
    word: "a obține"
  },
  {
    id: "1957",
    word: "bucurie"
  },
  {
    id: "1958",
    word: "a simți"
  },
  {
    id: "1960",
    word: "a scurta"
  },
  {
    id: "1961",
    word: "varză roșie"
  },
  {
    id: "1962",
    word: "centrul orașului"
  },
  {
    id: "1963",
    word: "maree"
  },
  {
    id: "1964",
    word: "suspiciune"
  },
  {
    id: "1965",
    word: "Jeep"
  },
  {
    id: "1966",
    word: "grijă"
  },
  {
    id: "1967",
    word: "a fi numit"
  },
  {
    id: "1968",
    word: "arcaș"
  },
  {
    id: "1970",
    word: "mod de viață"
  },
  {
    id: "1971",
    word: "păstor"
  },
  {
    id: "1972",
    word: "lentilă"
  },
  {
    id: "1973",
    word: "a consolida"
  },
  {
    id: "1977",
    word: "insurgent"
  },
  {
    id: "1979",
    word: "recepție"
  },
  {
    id: "1982",
    word: "habitat"
  },
  {
    id: "1984",
    word: "serviciu"
  },
  {
    id: "1987",
    word: "rachetă"
  },
  {
    id: "1988",
    word: "etic"
  },
  {
    id: "1990",
    word: "sunet"
  },
  {
    id: "1992",
    word: "personalitate"
  },
  {
    id: "1993",
    word: "campus"
  },
  {
    id: "1994",
    word: "blestem"
  },
  {
    id: "1996",
    word: "impuls"
  },
  {
    id: "1997",
    word: "frustrare"
  },
  {
    id: "1998",
    word: "pompă"
  },
  {
    id: "1999",
    word: "bun"
  },
  {
    id: "2002",
    word: "cosmetice"
  },
  {
    id: "2004",
    word: "a servi"
  },
  {
    id: "2005",
    word: "a forța"
  },
  {
    id: "2006",
    word: "a face o drumeție"
  },
  {
    id: "2010",
    word: "a face confuzie"
  },
  {
    id: "2011",
    word: "a ilustra"
  },
  {
    id: "2012",
    word: "a atrage atenția"
  },
  {
    id: "2013",
    word: "sirenă"
  },
  {
    id: "2015",
    word: "tradiție"
  },
  {
    id: "2018",
    word: "pirat"
  },
  {
    id: "2019",
    word: "descriere"
  },
  {
    id: "2020",
    word: "domn"
  },
  {
    id: "2021",
    word: "haină"
  },
  {
    id: "2022",
    word: "public"
  },
  {
    id: "2023",
    word: "condiție"
  },
  {
    id: "2024",
    word: "politică"
  },
  {
    id: "2025",
    word: "judecător"
  },
  {
    id: "2026",
    word: "foame"
  },
  {
    id: "2027",
    word: "geniu"
  },
  {
    id: "2028",
    word: "capră"
  },
  {
    id: "2029",
    word: "victorie"
  },
  {
    id: "2030",
    word: "combinație"
  },
  {
    id: "2033",
    word: "capă"
  },
  {
    id: "2034",
    word: "reflector"
  },
  {
    id: "2035",
    word: "guvernator"
  },
  {
    id: "2036",
    word: "oxigen"
  },
  {
    id: "2037",
    word: "episcop"
  },
  {
    id: "2038",
    word: "conectat"
  },
  {
    id: "2039",
    word: "dezvoltare"
  },
  {
    id: "2040",
    word: "unghie"
  },
  {
    id: "2045",
    word: "orbită"
  },
  {
    id: "2046",
    word: "viță"
  },
  {
    id: "2047",
    word: "a apărea"
  },
  {
    id: "2048",
    word: "barman"
  },
  {
    id: "2050",
    word: "melodie"
  },
  {
    id: "2051",
    word: "a obține"
  },
  {
    id: "2053",
    word: "a șicana"
  },
  {
    id: "2054",
    word: "a provoca"
  },
  {
    id: "2055",
    word: "a câștiga"
  },
  {
    id: "2056",
    word: "sistem de alarmă"
  },
  {
    id: "2057",
    word: "a mușca"
  },
  {
    id: "2058",
    word: "a economisi"
  },
  {
    id: "2059",
    word: "a expune"
  },
  {
    id: "2060",
    word: "a lupta"
  },
  {
    id: "2061",
    word: "glorie"
  },
  {
    id: "2063",
    word: "operație"
  },
  {
    id: "2064",
    word: "bovină"
  },
  {
    id: "2065",
    word: "ritual"
  },
  {
    id: "2066",
    word: "salut"
  },
  {
    id: "2067",
    word: "felie"
  },
  {
    id: "2069",
    word: "șemineu"
  },
  {
    id: "2070",
    word: "tricou"
  },
  {
    id: "2072",
    word: "a binecuvânta"
  },
  {
    id: "2073",
    word: "încărcătură"
  },
  {
    id: "2074",
    word: "han"
  },
  {
    id: "2077",
    word: "a încărca"
  },
  {
    id: "2078",
    word: "a ștampila"
  },
  {
    id: "2079",
    word: "jazz"
  },
  {
    id: "2080",
    word: "îmbrățișare"
  },
  {
    id: "2081",
    word: "fluier"
  },
  {
    id: "2082",
    word: "omenire"
  },
  {
    id: "2083",
    word: "meșteșug"
  },
  {
    id: "2087",
    word: "armură"
  },
  {
    id: "2088",
    word: "rucsac"
  },
  {
    id: "2089",
    word: "sugestie"
  },
  {
    id: "2090",
    word: "fosilă"
  },
  {
    id: "2091",
    word: "simbol"
  },
  {
    id: "2092",
    word: "colonie"
  },
  {
    id: "2093",
    word: "concluzie"
  },
  {
    id: "2094",
    word: "nară"
  },
  {
    id: "2095",
    word: "suliță"
  },
  {
    id: "2096",
    word: "a presupune"
  },
  {
    id: "2097",
    word: "speranță"
  },
  {
    id: "2099",
    word: "muzical"
  },
  {
    id: "2100",
    word: "descoperire"
  },
  {
    id: "2101",
    word: "a se scufunda"
  },
  {
    id: "2103",
    word: "a conține"
  },
  {
    id: "2104",
    word: "a lumina"
  },
  {
    id: "2105",
    word: "bancă"
  },
  {
    id: "2106",
    word: "a fi uimit"
  },
  {
    id: "2107",
    word: "a fluiera"
  },
  {
    id: "2108",
    word: "a râde"
  },
  {
    id: "2109",
    word: "gândac"
  },
  {
    id: "2110",
    word: "a semăna cu"
  },
  {
    id: "2111",
    word: "sală de clasă"
  },
  {
    id: "2112",
    word: "clasificare"
  },
  {
    id: "2113",
    word: "spray"
  },
  {
    id: "2114",
    word: "lichid"
  },
  {
    id: "2115",
    word: "jogging"
  },
  {
    id: "2116",
    word: "lenjerie intimă"
  },
  {
    id: "2118",
    word: "populație"
  },
  {
    id: "2120",
    word: "religie"
  },
  {
    id: "2121",
    word: "locație"
  },
  {
    id: "2122",
    word: "participant"
  },
  {
    id: "2123",
    word: "iluzie"
  },
  {
    id: "2125",
    word: "dependent"
  },
  {
    id: "2128",
    word: "a compara"
  },
  {
    id: "2129",
    word: "standard"
  },
  {
    id: "2130",
    word: "suprafață"
  },
  {
    id: "2132",
    word: "a petici"
  },
  {
    id: "2133",
    word: "farmec"
  },
  {
    id: "2134",
    word: "legendă"
  },
  {
    id: "2135",
    word: "consecință"
  },
  {
    id: "2136",
    word: "observare"
  },
  {
    id: "2141",
    word: "metrou"
  },
  {
    id: "2142",
    word: "mostră"
  },
  {
    id: "2143",
    word: "cireașă"
  },
  {
    id: "2144",
    word: "dealer"
  },
  {
    id: "2145",
    word: "mașină de tuns iarba"
  },
  {
    id: "2146",
    word: "grabă"
  },
  {
    id: "2147",
    word: "farfurii"
  },
  {
    id: "2150",
    word: "comitet"
  },
  {
    id: "2151",
    word: "poartă"
  },
  {
    id: "2153",
    word: "a îndoi"
  },
  {
    id: "2154",
    word: "a înjunghia"
  },
  {
    id: "2156",
    word: "a se ruga"
  },
  {
    id: "2158",
    word: "a lua micul dejun"
  },
  {
    id: "2159",
    word: "a picta"
  },
  {
    id: "2160",
    word: "fals"
  },
  {
    id: "2161",
    word: "ecou"
  },
  {
    id: "2162",
    word: "toaster"
  },
  {
    id: "2163",
    word: "furcă"
  },
  {
    id: "2164",
    word: "magazie"
  },
  {
    id: "2165",
    word: "artificii"
  },
  {
    id: "2166",
    word: "toast"
  },
  {
    id: "2168",
    word: "luminozitate"
  },
  {
    id: "2169",
    word: "celulă"
  },
  {
    id: "2170",
    word: "senator"
  },
  {
    id: "2171",
    word: "chitarist"
  },
  {
    id: "2172",
    word: "pleoapă"
  },
  {
    id: "2173",
    word: "entuziasm"
  },
  {
    id: "2176",
    word: "trupă"
  },
  {
    id: "2179",
    word: "predicator"
  },
  {
    id: "2182",
    word: "pânză de in"
  },
  {
    id: "2183",
    word: "scuză"
  },
  {
    id: "2186",
    word: "morman"
  },
  {
    id: "2187",
    word: "fotograf"
  },
  {
    id: "2188",
    word: "frână"
  },
  {
    id: "2190",
    word: "șorț"
  },
  {
    id: "2192",
    word: "juriu"
  },
  {
    id: "2193",
    word: "meteorit"
  },
  {
    id: "2196",
    word: "șampon"
  },
  {
    id: "2197",
    word: "referință"
  },
  {
    id: "2199",
    word: "flotă"
  },
  {
    id: "2200",
    word: "ruj"
  },
  {
    id: "2201",
    word: "a străluci"
  },
  {
    id: "2202",
    word: "a fi valabil"
  },
  {
    id: "2203",
    word: "a estima"
  },
  {
    id: "2204",
    word: "a lăuda"
  },
  {
    id: "2205",
    word: "a regla"
  },
  {
    id: "2206",
    word: "a zdrobi"
  },
  {
    id: "2207",
    word: "scrimă"
  },
  {
    id: "2208",
    word: "a zgâria"
  },
  {
    id: "2209",
    word: "a împărți"
  },
  {
    id: "2210",
    word: "miez"
  },
  {
    id: "2217",
    word: "furtun"
  },
  {
    id: "2218",
    word: "preș"
  },
  {
    id: "2220",
    word: "cale ferată"
  },
  {
    id: "2221",
    word: "paradă"
  },
  {
    id: "2224",
    word: "cuptor"
  },
  {
    id: "2225",
    word: "tehnician"
  },
  {
    id: "2226",
    word: "procedură"
  },
  {
    id: "2227",
    word: "luptător"
  },
  {
    id: "2228",
    word: "cereale"
  },
  {
    id: "2229",
    word: "țipăt"
  },
  {
    id: "2230",
    word: "trunchi"
  },
  {
    id: "2231",
    word: "mugur"
  },
  {
    id: "2232",
    word: "luncă"
  },
  {
    id: "2233",
    word: "public"
  },
  {
    id: "2235",
    word: "bivol"
  },
  {
    id: "2236",
    word: "regiune"
  },
  {
    id: "2237",
    word: "producție"
  },
  {
    id: "2238",
    word: "bulă de săpun"
  },
  {
    id: "2241",
    word: "idiot"
  },
  {
    id: "2242",
    word: "bufniță"
  },
  {
    id: "2244",
    word: "înalt"
  },
  {
    id: "2245",
    word: "a ruina"
  },
  {
    id: "2246",
    word: "rampă"
  },
  {
    id: "2249",
    word: "unghieră"
  },
  {
    id: "2250",
    word: "îngust la minte"
  },
  {
    id: "2251",
    word: "a sări"
  },
  {
    id: "2252",
    word: "a cântări"
  },
  {
    id: "2253",
    word: "a călători"
  },
  {
    id: "2254",
    word: "ardei"
  },
  {
    id: "2255",
    word: "a lega"
  },
  {
    id: "2258",
    word: "curs"
  },
  {
    id: "2259",
    word: "a prepara"
  },
  {
    id: "2261",
    word: "gâscă"
  },
  {
    id: "2262",
    word: "clasa întâi"
  },
  {
    id: "2264",
    word: "echipaj"
  },
  {
    id: "2265",
    word: "vorbăreț"
  },
  {
    id: "2266",
    word: "oficial"
  },
  {
    id: "2267",
    word: "brand"
  },
  {
    id: "2268",
    word: "organ"
  },
  {
    id: "2269",
    word: "palmier"
  },
  {
    id: "2270",
    word: "împărăție"
  },
  {
    id: "2271",
    word: "profil"
  },
  {
    id: "2274",
    word: "crâng"
  },
  {
    id: "2278",
    word: "mulțime"
  },
  {
    id: "2279",
    word: "satelit"
  },
  {
    id: "2281",
    word: "cățeluș"
  },
  {
    id: "2283",
    word: "bec"
  },
  {
    id: "2285",
    word: "patrulă"
  },
  {
    id: "2286",
    word: "vultur"
  },
  {
    id: "2288",
    word: "lichid"
  },
  {
    id: "2289",
    word: "semn"
  },
  {
    id: "2291",
    word: "parc de distracții"
  },
  {
    id: "2292",
    word: "scaun cu rotile"
  },
  {
    id: "2295",
    word: "a avea loc"
  },
  {
    id: "2296",
    word: "ajustare"
  },
  {
    id: "2297",
    word: "tatuaj"
  },
  {
    id: "2298",
    word: "povară"
  },
  {
    id: "2299",
    word: "capricios"
  },
  {
    id: "2300",
    word: "tobogan"
  },
  {
    id: "2301",
    word: "a se potrivi"
  },
  {
    id: "2302",
    word: "conductor"
  },
  {
    id: "2304",
    word: "a produce mâncărime"
  },
  {
    id: "2306",
    word: "a da în judecată"
  },
  {
    id: "2308",
    word: "a trage apa"
  },
  {
    id: "2310",
    word: "a inunda"
  },
  {
    id: "2311",
    word: "pată"
  },
  {
    id: "2314",
    word: "disperat"
  },
  {
    id: "2316",
    word: "proces"
  },
  {
    id: "2317",
    word: "ligă"
  },
  {
    id: "2318",
    word: "cer"
  },
  {
    id: "2319",
    word: "peluză"
  },
  {
    id: "2320",
    word: "împărat"
  },
  {
    id: "2323",
    word: "înțelepciune"
  },
  {
    id: "2325",
    word: "mansardă"
  },
  {
    id: "2326",
    word: "parcare"
  },
  {
    id: "2328",
    word: "strămoș"
  },
  {
    id: "2329",
    word: "concentrare"
  },
  {
    id: "2331",
    word: "efort"
  },
  {
    id: "2332",
    word: "binecuvântare"
  },
  {
    id: "2335",
    word: "torță"
  },
  {
    id: "2336",
    word: "cerneală"
  },
  {
    id: "2338",
    word: "chirie"
  },
  {
    id: "2339",
    word: "catâr"
  },
  {
    id: "2341",
    word: "a aburi"
  },
  {
    id: "2343",
    word: "inspector"
  },
  {
    id: "2346",
    word: "plângere"
  },
  {
    id: "2347",
    word: "porție"
  },
  {
    id: "2349",
    word: "cartofi prăjiți"
  },
  {
    id: "2350",
    word: "criză"
  },
  {
    id: "2352",
    word: "a face magie"
  },
  {
    id: "2354",
    word: "a se îmbrăca"
  },
  {
    id: "2355",
    word: "a minți"
  },
  {
    id: "2356",
    word: "inel"
  },
  {
    id: "2357",
    word: "muștar"
  },
  {
    id: "2358",
    word: "a se rupe"
  },
  {
    id: "2359",
    word: "a suge"
  },
  {
    id: "2360",
    word: "a pisa"
  },
  {
    id: "2361",
    word: "crăpătură"
  },
  {
    id: "2362",
    word: "felinar"
  },
  {
    id: "2363",
    word: "bogăție"
  },
  {
    id: "2365",
    word: "civilizație"
  },
  {
    id: "2366",
    word: "concept"
  },
  {
    id: "2367",
    word: "miel"
  },
  {
    id: "2369",
    word: "unt de arahide"
  },
  {
    id: "2370",
    word: "virgină"
  },
  {
    id: "2371",
    word: "veveriță"
  },
  {
    id: "2372",
    word: "gingie"
  },
  {
    id: "2374",
    word: "depresie"
  },
  {
    id: "2375",
    word: "magazie"
  },
  {
    id: "2377",
    word: "tragedie"
  },
  {
    id: "2380",
    word: "încredere"
  },
  {
    id: "2381",
    word: "contabil"
  },
  {
    id: "2382",
    word: "împărăție"
  },
  {
    id: "2383",
    word: "bijuterie"
  },
  {
    id: "2384",
    word: "castană"
  },
  {
    id: "2385",
    word: "a pronunța"
  },
  {
    id: "2386",
    word: "a dura"
  },
  {
    id: "2387",
    word: "hartă"
  },
  {
    id: "2388",
    word: "veterinar"
  },
  {
    id: "2389",
    word: "pompier"
  },
  {
    id: "2390",
    word: "protest"
  },
  {
    id: "2391",
    word: "dacă"
  },
  {
    id: "2392",
    word: "pupilă"
  },
  {
    id: "2393",
    word: "jurnal"
  },
  {
    id: "2394",
    word: "cod poștal"
  },
  {
    id: "2396",
    word: "papuc"
  },
  {
    id: "2397",
    word: "actriță"
  },
  {
    id: "2399",
    word: "cercel"
  },
  {
    id: "2400",
    word: "furnică"
  },
  {
    id: "2401",
    word: "a chițăi"
  },
  {
    id: "2402",
    word: "atenție"
  },
  {
    id: "2403",
    word: "a se uita"
  },
  {
    id: "2404",
    word: "a surprinde"
  },
  {
    id: "2405",
    word: "coridor"
  },
  {
    id: "2406",
    word: "a întâlni"
  },
  {
    id: "2408",
    word: "a planta"
  },
  {
    id: "2410",
    word: "cuptor cu microunde"
  },
  {
    id: "2412",
    word: "pungă de cumpărături"
  },
  {
    id: "2414",
    word: "intensitate"
  },
  {
    id: "2416",
    word: "margaretă"
  },
  {
    id: "2418",
    word: "mlaștină"
  },
  {
    id: "2419",
    word: "relație"
  },
  {
    id: "2420",
    word: "bănuire"
  },
  {
    id: "2422",
    word: "întâlnire"
  },
  {
    id: "2423",
    word: "secvență"
  },
  {
    id: "2424",
    word: "alfabet"
  },
  {
    id: "2425",
    word: "schiță"
  },
  {
    id: "2426",
    word: "cină"
  },
  {
    id: "2427",
    word: "funcție"
  },
  {
    id: "2428",
    word: "organizație"
  },
  {
    id: "2429",
    word: "schelet"
  },
  {
    id: "2430",
    word: "mizerie"
  },
  {
    id: "2431",
    word: "plantă"
  },
  {
    id: "2432",
    word: "trunchi"
  },
  {
    id: "2433",
    word: "cameraman"
  },
  {
    id: "2434",
    word: "grenadă"
  },
  {
    id: "2436",
    word: "mop"
  },
  {
    id: "2439",
    word: "alună de pădure"
  },
  {
    id: "2440",
    word: "amurg"
  },
  {
    id: "2442",
    word: "pedeapsă"
  },
  {
    id: "2443",
    word: "a face check-in"
  },
  {
    id: "2444",
    word: "cupru"
  },
  {
    id: "2446",
    word: "tablă neagră"
  },
  {
    id: "2447",
    word: "întâlnire"
  },
  {
    id: "2448",
    word: "matematică"
  },
  {
    id: "2449",
    word: "recunoaștere"
  },
  {
    id: "2451",
    word: "a putea"
  },
  {
    id: "2453",
    word: "a întâlni"
  },
  {
    id: "2454",
    word: "a se împerechea"
  },
  {
    id: "2455",
    word: "a se răci"
  },
  {
    id: "2456",
    word: "a da din cap"
  },
  {
    id: "2457",
    word: "la mâna a doua"
  },
  {
    id: "2458",
    word: "a face plinul"
  },
  {
    id: "2459",
    word: "trusă de scule"
  },
  {
    id: "2460",
    word: "a picura"
  },
  {
    id: "2461",
    word: "regret"
  },
  {
    id: "2463",
    word: "moară"
  },
  {
    id: "2464",
    word: "nucă"
  },
  {
    id: "2465",
    word: "harpă"
  },
  {
    id: "2466",
    word: "a face cu mâna"
  },
  {
    id: "2467",
    word: "a coase"
  },
  {
    id: "2468",
    word: "lopată"
  },
  {
    id: "2469",
    word: "pijamale"
  },
  {
    id: "2470",
    word: "e-mail"
  },
  {
    id: "2471",
    word: "porumbel"
  },
  {
    id: "2472",
    word: "dinozaur"
  },
  {
    id: "2473",
    word: "industrie"
  },
  {
    id: "2476",
    word: "consilier"
  },
  {
    id: "2478",
    word: "principiu"
  },
  {
    id: "2479",
    word: "dramă"
  },
  {
    id: "2480",
    word: "pui"
  },
  {
    id: "2481",
    word: "diagramă"
  },
  {
    id: "2482",
    word: "campanie"
  },
  {
    id: "2483",
    word: "laur"
  },
  {
    id: "2484",
    word: "friptură"
  },
  {
    id: "2485",
    word: "criminal"
  },
  {
    id: "2486",
    word: "glob"
  },
  {
    id: "2487",
    word: "vânătaie"
  },
  {
    id: "2488",
    word: "a face check-out"
  },
  {
    id: "2491",
    word: "operă"
  },
  {
    id: "2494",
    word: "șiret"
  },
  {
    id: "2495",
    word: "portbagaj"
  },
  {
    id: "2497",
    word: "benzină"
  },
  {
    id: "2498",
    word: "slăbiciune"
  },
  {
    id: "2499",
    word: "centură de siguranță"
  },
  {
    id: "2500",
    word: "sortiment"
  },
  {
    id: "2502",
    word: "a face publicitate"
  },
  {
    id: "2504",
    word: "cub"
  },
  {
    id: "2505",
    word: "mașină de cafea"
  },
  {
    id: "2506",
    word: "mașină de spălat vase"
  },
  {
    id: "2507",
    word: "mașină de spălat"
  },
  {
    id: "2508",
    word: "uscător de rufe"
  },
  {
    id: "2509",
    word: "fân"
  },
  {
    id: "2511",
    word: "supraviețuire"
  },
  {
    id: "2512",
    word: "paturi suprapuse"
  },
  {
    id: "2513",
    word: "curbă"
  },
  {
    id: "2514",
    word: "aprobare"
  },
  {
    id: "2515",
    word: "parter"
  },
  {
    id: "2516",
    word: "control"
  },
  {
    id: "2517",
    word: "detergent"
  },
  {
    id: "2518",
    word: "paradis"
  },
  {
    id: "2519",
    word: "lamă de ras"
  },
  {
    id: "2522",
    word: "baltă"
  },
  {
    id: "2523",
    word: "electricitate"
  },
  {
    id: "2524",
    word: "ceapă"
  },
  {
    id: "2525",
    word: "laser"
  },
  {
    id: "2526",
    word: "homar"
  },
  {
    id: "2527",
    word: "influență"
  },
  {
    id: "2529",
    word: "ciment"
  },
  {
    id: "2531",
    word: "zeiță"
  },
  {
    id: "2532",
    word: "cec"
  },
  {
    id: "2533",
    word: "masă de călcat"
  },
  {
    id: "2534",
    word: "căști"
  },
  {
    id: "2536",
    word: "coadă"
  },
  {
    id: "2537",
    word: "țurțure"
  },
  {
    id: "2538",
    word: "demnitate"
  },
  {
    id: "2539",
    word: "crin"
  },
  {
    id: "2540",
    word: "clovn"
  },
  {
    id: "2541",
    word: "secție de poliție"
  },
  {
    id: "2543",
    word: "distrugere"
  },
  {
    id: "2544",
    word: "excepție"
  },
  {
    id: "2545",
    word: "piersică"
  },
  {
    id: "2546",
    word: "conductor"
  },
  {
    id: "2547",
    word: "a elibera"
  },
  {
    id: "2549",
    word: "sală de așteptare"
  },
  {
    id: "2550",
    word: "sutien"
  },
  {
    id: "2551",
    word: "datorie"
  },
  {
    id: "2552",
    word: "terasă"
  },
  {
    id: "2553",
    word: "resturi"
  },
  {
    id: "2554",
    word: "logică"
  },
  {
    id: "2555",
    word: "articulație"
  },
  {
    id: "2557",
    word: "perspectivă"
  },
  {
    id: "2558",
    word: "recoltă"
  },
  {
    id: "2559",
    word: "diplomă"
  },
  {
    id: "2561",
    word: "supraviețuitor"
  },
  {
    id: "2562",
    word: "plată"
  },
  {
    id: "2563",
    word: "pariu"
  },
  {
    id: "2564",
    word: "răzbunare"
  },
  {
    id: "2566",
    word: "geantă"
  },
  {
    id: "2567",
    word: "ghimbir"
  },
  {
    id: "2568",
    word: "chirurg"
  },
  {
    id: "2570",
    word: "sandală"
  },
  {
    id: "2571",
    word: "ură"
  },
  {
    id: "2572",
    word: "plecare"
  },
  {
    id: "2574",
    word: "corb"
  },
  {
    id: "2577",
    word: "traducere"
  },
  {
    id: "2578",
    word: "sediu central"
  },
  {
    id: "2579",
    word: "sărbătorire"
  },
  {
    id: "2580",
    word: "agonie"
  },
  {
    id: "2581",
    word: "adidași"
  },
  {
    id: "2582",
    word: "terminal"
  },
  {
    id: "2583",
    word: "așteptare"
  },
  {
    id: "2584",
    word: "pășune"
  },
  {
    id: "2586",
    word: "viață de noapte"
  },
  {
    id: "2587",
    word: "meniu"
  },
  {
    id: "2588",
    word: "insignă"
  },
  {
    id: "2590",
    word: "schi"
  },
  {
    id: "2592",
    word: "pastor"
  },
  {
    id: "2593",
    word: "a expira"
  },
  {
    id: "2595",
    word: "butic"
  },
  {
    id: "2596",
    word: "caritate"
  },
  {
    id: "2597",
    word: "proiector"
  },
  {
    id: "2598",
    word: "aplauze"
  },
  {
    id: "2599",
    word: "filosofie"
  },
  {
    id: "2600",
    word: "tornadă"
  },
  {
    id: "2601",
    word: "vamă"
  },
  {
    id: "2602",
    word: "nepot"
  },
  {
    id: "2603",
    word: "eseu"
  },
  {
    id: "2604",
    word: "a repara"
  },
  {
    id: "2605",
    word: "apă de gură"
  },
  {
    id: "2607",
    word: "barieră"
  },
  {
    id: "2609",
    word: "gumă de mestecat"
  },
  {
    id: "2610",
    word: "cercetaș"
  },
  {
    id: "2611",
    word: "importanță"
  },
  {
    id: "2612",
    word: "destin"
  },
  {
    id: "2613",
    word: "aparat dentar"
  },
  {
    id: "2614",
    word: "microfon"
  },
  {
    id: "2615",
    word: "etichetă"
  },
  {
    id: "2617",
    word: "radiator"
  },
  {
    id: "2618",
    word: "predare"
  },
  {
    id: "2619",
    word: "diagnostic"
  },
  {
    id: "2620",
    word: "vestă"
  },
  {
    id: "2621",
    word: "ponei"
  },
  {
    id: "2622",
    word: "comandă"
  },
  {
    id: "2625",
    word: "ironie"
  },
  {
    id: "2626",
    word: "premiu"
  },
  {
    id: "2627",
    word: "strugure"
  },
  {
    id: "2628",
    word: "ezitare"
  },
  {
    id: "2629",
    word: "tavernă"
  },
  {
    id: "2630",
    word: "insomnie"
  },
  {
    id: "2631",
    word: "sferă"
  },
  {
    id: "2632",
    word: "velă"
  },
  {
    id: "2633",
    word: "siluetă"
  },
  {
    id: "2634",
    word: "institut"
  },
  {
    id: "2635",
    word: "mincinos"
  },
  {
    id: "2636",
    word: "tehnică"
  },
  {
    id: "2637",
    word: "indice"
  },
  {
    id: "2640",
    word: "creștere"
  },
  {
    id: "2641",
    word: "arhitect"
  },
  {
    id: "2643",
    word: "două puncte"
  },
  {
    id: "2644",
    word: "brățară"
  },
  {
    id: "2646",
    word: "dietă"
  },
  {
    id: "2647",
    word: "zig-zag"
  },
  {
    id: "2648",
    word: "beton"
  },
  {
    id: "2649",
    word: "opus"
  },
  {
    id: "2650",
    word: "drapel"
  },
  {
    id: "2651",
    word: "rezistență"
  },
  {
    id: "2652",
    word: "suvenir"
  },
  {
    id: "2653",
    word: "postură"
  },
  {
    id: "2655",
    word: "album"
  },
  {
    id: "2656",
    word: "epocă"
  },
  {
    id: "2657",
    word: "cunoștință"
  },
  {
    id: "2658",
    word: "revoluție"
  },
  {
    id: "2659",
    word: "pui de somn"
  },
  {
    id: "2660",
    word: "voal"
  },
  {
    id: "2662",
    word: "competiție"
  },
  {
    id: "2663",
    word: "scalp"
  },
  {
    id: "2665",
    word: "câștigător"
  },
  {
    id: "2666",
    word: "apetit"
  },
  {
    id: "2667",
    word: "iederă"
  },
  {
    id: "2670",
    word: "nepoată"
  },
  {
    id: "2671",
    word: "galaxie"
  },
  {
    id: "2672",
    word: "ginecolog"
  },
  {
    id: "2673",
    word: "nebunie"
  },
  {
    id: "2674",
    word: "bucătar"
  },
  {
    id: "2675",
    word: "virus"
  },
  {
    id: "2676",
    word: "suferință"
  },
  {
    id: "2677",
    word: "a periclita"
  },
  {
    id: "2678",
    word: "dosar"
  },
  {
    id: "2679",
    word: "confesiune"
  },
  {
    id: "2682",
    word: "ghenă de gunoi"
  },
  {
    id: "2683",
    word: "moașă"
  },
  {
    id: "2684",
    word: "profit"
  },
  {
    id: "2685",
    word: "ultrasunete"
  },
  {
    id: "2686",
    word: "bârfă"
  },
  {
    id: "2687",
    word: "iapă"
  },
  {
    id: "2691",
    word: "copită"
  },
  {
    id: "2692",
    word: "senzor"
  },
  {
    id: "2693",
    word: "țăran"
  },
  {
    id: "2695",
    word: "terapie"
  },
  {
    id: "2696",
    word: "rugăciune"
  },
  {
    id: "2697",
    word: "titlu"
  },
  {
    id: "2698",
    word: "șuncă"
  },
  {
    id: "2699",
    word: "versuri"
  },
  {
    id: "2700",
    word: "vioară"
  },
  {
    id: "2701",
    word: "umeraș"
  },
  {
    id: "2702",
    word: "estompare"
  },
  {
    id: "2706",
    word: "a aresta"
  },
  {
    id: "2707",
    word: "banană"
  },
  {
    id: "2708",
    word: "a face scufundări"
  },
  {
    id: "2710",
    word: "rechin"
  },
  {
    id: "2711",
    word: "pregătire"
  },
  {
    id: "2712",
    word: "zgârietură"
  },
  {
    id: "2713",
    word: "bandaj"
  },
  {
    id: "2714",
    word: "semnătură"
  },
  {
    id: "2715",
    word: "amiral"
  },
  {
    id: "2716",
    word: "analiză"
  },
  {
    id: "2717",
    word: "curcubeu"
  },
  {
    id: "2718",
    word: "șopârlă"
  },
  {
    id: "2719",
    word: "pitic"
  },
  {
    id: "2720",
    word: "răspundere"
  },
  {
    id: "2721",
    word: "teme"
  },
  {
    id: "2722",
    word: "amestec"
  },
  {
    id: "2723",
    word: "verset"
  },
  {
    id: "2725",
    word: "pantof cu toc"
  },
  {
    id: "2726",
    word: "ceas de mână"
  },
  {
    id: "2728",
    word: "expediție"
  },
  {
    id: "2729",
    word: "răsplată"
  },
  {
    id: "2730",
    word: "stâlp"
  },
  {
    id: "2731",
    word: "gem"
  },
  {
    id: "2737",
    word: "candidat"
  },
  {
    id: "2738",
    word: "o dată"
  },
  {
    id: "2741",
    word: "înregistrare"
  },
  {
    id: "2743",
    word: "cafenea"
  },
  {
    id: "2744",
    word: "taxă"
  },
  {
    id: "2745",
    word: "coastă de deal"
  },
  {
    id: "2746",
    word: "labirint"
  },
  {
    id: "2747",
    word: "pescar"
  },
  {
    id: "2751",
    word: "substanță"
  },
  {
    id: "2752",
    word: "orhidee"
  },
  {
    id: "2753",
    word: "bubuitură"
  },
  {
    id: "2754",
    word: "pumnal"
  },
  {
    id: "2755",
    word: "magnet"
  },
  {
    id: "2756",
    word: "dezavantaj"
  },
  {
    id: "2757",
    word: "singurătate"
  },
  {
    id: "2758",
    word: "motocicletă"
  },
  {
    id: "2759",
    word: "canar"
  },
  {
    id: "2760",
    word: "director"
  },
  {
    id: "2761",
    word: "geografie"
  },
  {
    id: "2763",
    word: "capacitate"
  },
  {
    id: "2769",
    word: "țânțar"
  },
  {
    id: "2770",
    word: "zar"
  },
  {
    id: "2772",
    word: "pătură"
  },
  {
    id: "2773",
    word: "cazino"
  },
  {
    id: "2774",
    word: "mazăre"
  },
  {
    id: "2775",
    word: "mormăit"
  },
  {
    id: "2776",
    word: "conflict"
  },
  {
    id: "2777",
    word: "deschis la minte"
  },
  {
    id: "2779",
    word: "cireadă"
  },
  {
    id: "2781",
    word: "sarcină"
  },
  {
    id: "2782",
    word: "suspect"
  },
  {
    id: "2783",
    word: "coincidență"
  },
  {
    id: "2784",
    word: "pădurar"
  },
  {
    id: "2785",
    word: "priveliște"
  },
  {
    id: "2786",
    word: "curte"
  },
  {
    id: "2790",
    word: "conștiință"
  },
  {
    id: "2791",
    word: "grătar"
  },
  {
    id: "2792",
    word: "conștiință"
  },
  {
    id: "2793",
    word: "circuit"
  },
  {
    id: "2794",
    word: "fildeș"
  },
  {
    id: "2795",
    word: "tâmplar"
  },
  {
    id: "2796",
    word: "anterior"
  },
  {
    id: "2798",
    word: "drept"
  },
  {
    id: "2799",
    word: "rezervare"
  },
  {
    id: "2801",
    word: "crab"
  },
  {
    id: "2803",
    word: "academie"
  },
  {
    id: "2804",
    word: "monoton"
  },
  {
    id: "2806",
    word: "burghiu"
  },
  {
    id: "2807",
    word: "bagaje"
  },
  {
    id: "2809",
    word: "emoție"
  },
  {
    id: "2810",
    word: "virtute"
  },
  {
    id: "2812",
    word: "horn"
  },
  {
    id: "2813",
    word: "ancoră"
  },
  {
    id: "2814",
    word: "armonie"
  },
  {
    id: "2816",
    word: "traumatizant"
  },
  {
    id: "2817",
    word: "cu adevărat"
  },
  {
    id: "2818",
    word: "tron"
  },
  {
    id: "2819",
    word: "cerere"
  },
  {
    id: "2820",
    word: "fizică"
  },
  {
    id: "2823",
    word: "oboseală"
  },
  {
    id: "2824",
    word: "Ziua Recunoștinței"
  },
  {
    id: "2826",
    word: "bază"
  },
  {
    id: "2828",
    word: "frecvent"
  },
  {
    id: "2834",
    word: "bronz"
  },
  {
    id: "2835",
    word: "asociație"
  },
  {
    id: "2836",
    word: "pernă"
  },
  {
    id: "2837",
    word: "castron de supă"
  },
  {
    id: "2839",
    word: "floricele"
  },
  {
    id: "2840",
    word: "record"
  },
  {
    id: "2841",
    word: "episod"
  },
  {
    id: "2842",
    word: "origine"
  },
  {
    id: "2844",
    word: "catedrală"
  },
  {
    id: "2847",
    word: "continent"
  },
  {
    id: "2848",
    word: "semn de întrebare"
  },
  {
    id: "2849",
    word: "voluntar"
  },
  {
    id: "2853",
    word: "dorință"
  },
  {
    id: "2854",
    word: "a chicoti"
  },
  {
    id: "2855",
    word: "coleg de clasă"
  },
  {
    id: "2856",
    word: "curățenie"
  },
  {
    id: "2857",
    word: "recepționer"
  },
  {
    id: "2858",
    word: "apelant"
  },
  {
    id: "2860",
    word: "dispreț"
  },
  {
    id: "2862",
    word: "bunici"
  },
  {
    id: "2863",
    word: "locomotivă"
  },
  {
    id: "2864",
    word: "acțiune"
  },
  {
    id: "2865",
    word: "țară"
  },
  {
    id: "2866",
    word: "aproximativ"
  },
  {
    id: "2867",
    word: "rid"
  },
  {
    id: "2874",
    word: "anunț"
  },
  {
    id: "2877",
    word: "aliat"
  },
  {
    id: "2879",
    word: "vânzător"
  },
  {
    id: "2880",
    word: "terapeut"
  },
  {
    id: "2882",
    word: "scenă"
  },
  {
    id: "2883",
    word: "bandaj"
  },
  {
    id: "2884",
    word: "șuncă"
  },
  {
    id: "2885",
    word: "deseori"
  },
  {
    id: "2886",
    word: "investiție"
  },
  {
    id: "2888",
    word: "inocență"
  },
  {
    id: "2892",
    word: "bandă de alergare"
  },
  {
    id: "2893",
    word: "clătită"
  },
  {
    id: "2894",
    word: "asteroid"
  },
  {
    id: "2895",
    word: "carte poștală"
  },
  {
    id: "2898",
    word: "tractor"
  },
  {
    id: "2902",
    word: "a împiedica"
  },
  {
    id: "2904",
    word: "majordom"
  },
  {
    id: "2905",
    word: "tuse"
  },
  {
    id: "2907",
    word: "ambasador"
  },
  {
    id: "2908",
    word: "abia"
  },
  {
    id: "2909",
    word: "a se ridica"
  },
  {
    id: "2910",
    word: "compliment"
  },
  {
    id: "2911",
    word: "cutie"
  },
  {
    id: "2912",
    word: "sonerie"
  },
  {
    id: "2914",
    word: "politician"
  },
  {
    id: "2915",
    word: "recunoștință"
  },
  {
    id: "2916",
    word: "logodit"
  },
  {
    id: "2918",
    word: "plasture"
  },
  {
    id: "2923",
    word: "bulevard"
  },
  {
    id: "2925",
    word: "carte de bucate"
  },
  {
    id: "2926",
    word: "răbdător"
  },
  {
    id: "2927",
    word: "retragere"
  },
  {
    id: "2931",
    word: "editor"
  },
  {
    id: "2932",
    word: "circ"
  },
  {
    id: "2933",
    word: "dimensiune"
  },
  {
    id: "2934",
    word: "grădină zoologică"
  },
  {
    id: "2938",
    word: "căsuța câinelui"
  },
  {
    id: "2939",
    word: "personal"
  },
  {
    id: "2940",
    word: "strategie"
  },
  {
    id: "2941",
    word: "disperare"
  },
  {
    id: "2942",
    word: "om de afaceri"
  },
  {
    id: "2945",
    word: "căpșuni"
  },
  {
    id: "2946",
    word: "aniversare"
  },
  {
    id: "2947",
    word: "binoclu"
  },
  {
    id: "2949",
    word: "disciplină"
  },
  {
    id: "2951",
    word: "liber"
  },
  {
    id: "2952",
    word: "venit"
  },
  {
    id: "2953",
    word: "mit"
  },
  {
    id: "2954",
    word: "obloane"
  },
  {
    id: "2955",
    word: "barcă"
  },
  {
    id: "2956",
    word: "drujbă"
  },
  {
    id: "2957",
    word: "ambiție"
  },
  {
    id: "2958",
    word: "cămilă"
  },
  {
    id: "2960",
    word: "acid"
  },
  {
    id: "2963",
    word: "rochie de noapte"
  },
  {
    id: "2965",
    word: "carlingă"
  },
  {
    id: "2966",
    word: "epavă"
  },
  {
    id: "2967",
    word: "perucă"
  },
  {
    id: "2969",
    word: "înregistrator"
  },
  {
    id: "2970",
    word: "carne de porc"
  },
  {
    id: "2971",
    word: "reducere"
  },
  {
    id: "2972",
    word: "elastic"
  },
  {
    id: "2973",
    word: "examen"
  },
  {
    id: "2974",
    word: "curtoazie"
  },
  {
    id: "2976",
    word: "pomeți"
  },
  {
    id: "2977",
    word: "bici"
  },
  {
    id: "2979",
    word: "carnaval"
  },
  {
    id: "2980",
    word: "colaps"
  },
  {
    id: "2981",
    word: "facultate"
  },
  {
    id: "2982",
    word: "aducere aminte"
  },
  {
    id: "2984",
    word: "asfalt"
  },
  {
    id: "2985",
    word: "privilegiu"
  },
  {
    id: "2986",
    word: "a descărca"
  },
  {
    id: "2987",
    word: "întreținere"
  },
  {
    id: "2988",
    word: "septembrie"
  },
  {
    id: "2991",
    word: "detergent de vase"
  },
  {
    id: "2992",
    word: "brichetă"
  },
  {
    id: "2993",
    word: "fără gust"
  },
  {
    id: "2995",
    word: "gustare"
  },
  {
    id: "2996",
    word: "desen animat"
  },
  {
    id: "2997",
    word: "neînțelegere"
  },
  {
    id: "2998",
    word: "expresie"
  },
  {
    id: "2999",
    word: "globalizare"
  },
  {
    id: "3000",
    word: "președinte"
  },
  {
    id: "3001",
    word: "sumă"
  },
  {
    id: "3005",
    word: "a reflecta"
  },
  {
    id: "3007",
    word: "coadă de cal"
  },
  {
    id: "3008",
    word: "designer"
  },
  {
    id: "3009",
    word: "a reduce"
  },
  {
    id: "3010",
    word: "moștenitor"
  },
  {
    id: "3011",
    word: "efect de seră"
  },
  {
    id: "3021",
    word: "vânătă"
  },
  {
    id: "3022",
    word: "poker"
  },
  {
    id: "3024",
    word: "supraveghere"
  },
  {
    id: "3025",
    word: "corect"
  },
  {
    id: "3026",
    word: "nepot"
  },
  {
    id: "3028",
    word: "transportator"
  },
  {
    id: "3029",
    word: "logodnă"
  },
  {
    id: "3032",
    word: "iluminat"
  },
  {
    id: "3037",
    word: "Noua Zeelandă"
  },
  {
    id: "3038",
    word: "asasin"
  },
  {
    id: "3039",
    word: "spumă"
  },
  {
    id: "3041",
    word: "jurnalist"
  },
  {
    id: "3042",
    word: "înregistrare"
  },
  {
    id: "3043",
    word: "vindecare"
  },
  {
    id: "3044",
    word: "temniță"
  },
  {
    id: "3050",
    word: "adversar"
  },
  {
    id: "3051",
    word: "bucătar"
  },
  {
    id: "3052",
    word: "grâu"
  },
  {
    id: "3053",
    word: "uragan"
  },
  {
    id: "3054",
    word: "loc de joacă"
  },
  {
    id: "3055",
    word: "ciupercă"
  },
  {
    id: "3056",
    word: "tastatură"
  },
  {
    id: "3059",
    word: "iasomie"
  },
  {
    id: "3060",
    word: "fotoliu"
  },
  {
    id: "3062",
    word: "orb"
  },
  {
    id: "3063",
    word: "cilindru"
  },
  {
    id: "3065",
    word: "celebritate"
  },
  {
    id: "3067",
    word: "triunghi"
  },
  {
    id: "3068",
    word: "duhoare"
  },
  {
    id: "3069",
    word: "laborator"
  },
  {
    id: "3072",
    word: "pensionare"
  },
  {
    id: "3073",
    word: "a corecta"
  },
  {
    id: "3074",
    word: "ediție"
  },
  {
    id: "3076",
    word: "a traduce"
  },
  {
    id: "3077",
    word: "a îmbunătăți"
  },
  {
    id: "3078",
    word: "mușchi"
  },
  {
    id: "3079",
    word: "masă de cafea"
  },
  {
    id: "3080",
    word: "loialitate"
  },
  {
    id: "3081",
    word: "lavandă"
  },
  {
    id: "3083",
    word: "scrumieră"
  },
  {
    id: "3085",
    word: "a continua"
  },
  {
    id: "3088",
    word: "piramidă"
  },
  {
    id: "3089",
    word: "faimă"
  },
  {
    id: "3092",
    word: "magician"
  },
  {
    id: "3093",
    word: "independență"
  },
  {
    id: "3095",
    word: "limbă străină"
  },
  {
    id: "3096",
    word: "caz"
  },
  {
    id: "3097",
    word: "aproape"
  },
  {
    id: "3098",
    word: "a agita"
  },
  {
    id: "3102",
    word: "salariu"
  },
  {
    id: "3103",
    word: "prejudiciat"
  },
  {
    id: "3104",
    word: "rebel"
  },
  {
    id: "3106",
    word: "diferit"
  },
  {
    id: "3107",
    word: "frigider"
  },
  {
    id: "3108",
    word: "priză"
  },
  {
    id: "3109",
    word: "meduză"
  },
  {
    id: "3110",
    word: "alegere"
  },
  {
    id: "3111",
    word: "refugiat"
  },
  {
    id: "3112",
    word: "fază"
  },
  {
    id: "3113",
    word: "dovleac"
  },
  {
    id: "3114",
    word: "spin"
  },
  {
    id: "3116",
    word: "plăcut"
  },
  {
    id: "3117",
    word: "loc de întâlnire"
  },
  {
    id: "3118",
    word: "mizerie"
  },
  {
    id: "3119",
    word: "împrumut"
  },
  {
    id: "3120",
    word: "a funcționa"
  },
  {
    id: "3121",
    word: "firimitură"
  },
  {
    id: "3122",
    word: "ceară"
  },
  {
    id: "3123",
    word: "a cheltui"
  },
  {
    id: "3125",
    word: "nutreț"
  },
  {
    id: "3127",
    word: "uimire"
  },
  {
    id: "3128",
    word: "floră"
  },
  {
    id: "3129",
    word: "festival"
  },
  {
    id: "3130",
    word: "dezbatere"
  },
  {
    id: "3131",
    word: "critic"
  },
  {
    id: "3132",
    word: "distribuție"
  },
  {
    id: "3135",
    word: "comisie"
  },
  {
    id: "3137",
    word: "economie"
  },
  {
    id: "3138",
    word: "radiație"
  },
  {
    id: "3139",
    word: "gardă de corp"
  },
  {
    id: "3140",
    word: "urmăritor"
  },
  {
    id: "3141",
    word: "crater"
  },
  {
    id: "3142",
    word: "dur"
  },
  {
    id: "3143",
    word: "congres"
  },
  {
    id: "3145",
    word: "întreg"
  },
  {
    id: "3146",
    word: "matur"
  },
  {
    id: "3147",
    word: "cârpă de bucătărie"
  },
  {
    id: "3148",
    word: "obligație"
  },
  {
    id: "3150",
    word: "instructor"
  },
  {
    id: "3151",
    word: "păsări de curte"
  },
  {
    id: "3152",
    word: "tacâm"
  },
  {
    id: "3153",
    word: "nevoie"
  },
  {
    id: "3154",
    word: "atelier"
  },
  {
    id: "3155",
    word: "răsărit"
  },
  {
    id: "3157",
    word: "spanac"
  },
  {
    id: "3158",
    word: "chiftea"
  },
  {
    id: "3159",
    word: "suc de fructe"
  },
  {
    id: "3163",
    word: "interval"
  },
  {
    id: "3166",
    word: "donație"
  },
  {
    id: "3167",
    word: "minerală"
  },
  {
    id: "3169",
    word: "a participa"
  },
  {
    id: "3170",
    word: "insolație"
  },
  {
    id: "3171",
    word: "cusătură"
  },
  {
    id: "3172",
    word: "ciocănitoare"
  },
  {
    id: "3173",
    word: "bătrân"
  },
  {
    id: "3174",
    word: "a înghiți"
  },
  {
    id: "3177",
    word: "bluf"
  },
  {
    id: "3178",
    word: "muncitor în construcții"
  },
  {
    id: "3179",
    word: "dentist"
  },
  {
    id: "3181",
    word: "satin"
  },
  {
    id: "3184",
    word: "căsuță poștală"
  },
  {
    id: "3187",
    word: "trecere de pietoni"
  },
  {
    id: "3189",
    word: "pensionat"
  },
  {
    id: "3190",
    word: "făină"
  },
  {
    id: "3191",
    word: "bamă"
  },
  {
    id: "3192",
    word: "tunsoare"
  },
  {
    id: "3194",
    word: "orfan"
  },
  {
    id: "3195",
    word: "șah"
  },
  {
    id: "3198",
    word: "psihiatru"
  },
  {
    id: "3199",
    word: "a intra în"
  },
  {
    id: "3200",
    word: "a coborî din"
  },
  {
    id: "3202",
    word: "admirație"
  },
  {
    id: "3203",
    word: "congelator"
  },
  {
    id: "3204",
    word: "ilustrație"
  },
  {
    id: "3205",
    word: "tocană"
  },
  {
    id: "3207",
    word: "suburbie"
  },
  {
    id: "3210",
    word: "factor"
  },
  {
    id: "3211",
    word: "intimitate"
  },
  {
    id: "3212",
    word: "gene"
  },
  {
    id: "3213",
    word: "economie"
  },
  {
    id: "3214",
    word: "software"
  },
  {
    id: "3218",
    word: "pepinieră"
  },
  {
    id: "3219",
    word: "transport"
  },
  {
    id: "3220",
    word: "magnitudine"
  },
  {
    id: "3221",
    word: "definiție"
  },
  {
    id: "3222",
    word: "monument"
  },
  {
    id: "3223",
    word: "prună"
  },
  {
    id: "3224",
    word: "stație de autobuz"
  },
  {
    id: "3226",
    word: "inspecție"
  },
  {
    id: "3227",
    word: "esență"
  },
  {
    id: "3228",
    word: "tun"
  },
  {
    id: "3230",
    word: "stradă cu sens unic"
  },
  {
    id: "3232",
    word: "laudă"
  },
  {
    id: "3233",
    word: "pinguin"
  },
  {
    id: "3234",
    word: "strâmt"
  },
  {
    id: "3235",
    word: "timbru"
  },
  {
    id: "3236",
    word: "particulă"
  },
  {
    id: "3237",
    word: "traducător"
  },
  {
    id: "3244",
    word: "hârtie igienică"
  },
  {
    id: "3247",
    word: "ulcior"
  },
  {
    id: "3248",
    word: "poreclă"
  },
  {
    id: "3251",
    word: "carpetă"
  },
  {
    id: "3253",
    word: "terorist"
  },
  {
    id: "3254",
    word: "laptop"
  },
  {
    id: "3256",
    word: "cioc"
  },
  {
    id: "3257",
    word: "instituție"
  },
  {
    id: "3258",
    word: "comparație"
  },
  {
    id: "3260",
    word: "înțelegere"
  },
  {
    id: "3261",
    word: "frate"
  },
  {
    id: "3262",
    word: "dulap"
  },
  {
    id: "3263",
    word: "informal"
  },
  {
    id: "3264",
    word: "unic"
  },
  {
    id: "3265",
    word: "compasiune"
  },
  {
    id: "3266",
    word: "încălzire"
  },
  {
    id: "3267",
    word: "antenă"
  },
  {
    id: "3268",
    word: "perie de păr"
  },
  {
    id: "3270",
    word: "librărie"
  },
  {
    id: "3271",
    word: "slăbit"
  },
  {
    id: "3272",
    word: "obiecție"
  },
  {
    id: "3273",
    word: "a organiza"
  },
  {
    id: "3274",
    word: "bancheta din spate"
  },
  {
    id: "3275",
    word: "ignoranță"
  },
  {
    id: "3276",
    word: "buget"
  },
  {
    id: "3277",
    word: "cale"
  },
  {
    id: "3280",
    word: "extensie"
  },
  {
    id: "3281",
    word: "turism"
  },
  {
    id: "3283",
    word: "chimicală"
  },
  {
    id: "3285",
    word: "perfecțiune"
  },
  {
    id: "3287",
    word: "semestru"
  },
  {
    id: "3288",
    word: "ficat"
  },
  {
    id: "3290",
    word: "urgență"
  },
  {
    id: "3291",
    word: "vulcan"
  },
  {
    id: "3292",
    word: "condiment"
  },
  {
    id: "3293",
    word: "ostatic"
  },
  {
    id: "3294",
    word: "cor"
  },
  {
    id: "3295",
    word: "aluat"
  },
  {
    id: "3296",
    word: "a observa"
  },
  {
    id: "3298",
    word: "somon"
  },
  {
    id: "3299",
    word: "boxer"
  },
  {
    id: "3301",
    word: "parteneriat"
  },
  {
    id: "3302",
    word: "telescop"
  },
  {
    id: "3303",
    word: "feribot"
  },
  {
    id: "3307",
    word: "limuzină"
  },
  {
    id: "3309",
    word: "laș"
  },
  {
    id: "3310",
    word: "club"
  },
  {
    id: "3314",
    word: "socru"
  },
  {
    id: "3315",
    word: "a admira"
  },
  {
    id: "3317",
    word: "aer condiționat"
  },
  {
    id: "3318",
    word: "glugă"
  },
  {
    id: "3319",
    word: "rețetă"
  },
  {
    id: "3320",
    word: "hamburger"
  },
  {
    id: "3322",
    word: "frizer"
  },
  {
    id: "3323",
    word: "plăcere"
  },
  {
    id: "3324",
    word: "trădare"
  },
  {
    id: "3325",
    word: "hanorac"
  },
  {
    id: "3327",
    word: "sindrom"
  },
  {
    id: "3330",
    word: "înăuntru"
  },
  {
    id: "3331",
    word: "administrație"
  },
  {
    id: "3332",
    word: "loc de muncă"
  },
  {
    id: "3333",
    word: "scutec"
  },
  {
    id: "3335",
    word: "a aproba"
  },
  {
    id: "3336",
    word: "gripă"
  },
  {
    id: "3338",
    word: "diaree"
  },
  {
    id: "3340",
    word: "lecție"
  },
  {
    id: "3343",
    word: "sirop de tuse"
  },
  {
    id: "3345",
    word: "arbitru"
  },
  {
    id: "3346",
    word: "alternativă"
  },
  {
    id: "3348",
    word: "baraj"
  },
  {
    id: "3349",
    word: "abuz"
  },
  {
    id: "3350",
    word: "măsline"
  },
  {
    id: "3351",
    word: "miner"
  },
  {
    id: "3353",
    word: "aleatoriu"
  },
  {
    id: "3354",
    word: "a deocra"
  },
  {
    id: "3355",
    word: "documentar"
  },
  {
    id: "3359",
    word: "crainic"
  },
  {
    id: "3360",
    word: "cascadă"
  },
  {
    id: "3361",
    word: "topor"
  },
  {
    id: "3363",
    word: "pătuț"
  },
  {
    id: "3366",
    word: "aromă"
  },
  {
    id: "3367",
    word: "dialog"
  },
  {
    id: "3370",
    word: "teren"
  },
  {
    id: "3371",
    word: "subtitrare"
  },
  {
    id: "3372",
    word: "hardware"
  },
  {
    id: "3373",
    word: "generator"
  },
  {
    id: "3374",
    word: "lux"
  },
  {
    id: "3375",
    word: "auditoriu"
  },
  {
    id: "3376",
    word: "broșură"
  },
  {
    id: "3378",
    word: "înfrângere"
  },
  {
    id: "3379",
    word: "loțiune de protecție solară"
  },
  {
    id: "3381",
    word: "lângă"
  },
  {
    id: "3382",
    word: "cizme de cauciuc"
  },
  {
    id: "3383",
    word: "obsesie"
  },
  {
    id: "3384",
    word: "arsură solară"
  },
  {
    id: "3385",
    word: "însoțitor de zbor"
  },
  {
    id: "3386",
    word: "dormitor"
  },
  {
    id: "3388",
    word: "ferăstrău"
  },
  {
    id: "3390",
    word: "a polua"
  },
  {
    id: "3392",
    word: "întârziat"
  },
  {
    id: "3393",
    word: "a ascunde"
  },
  {
    id: "3395",
    word: "haină de ploaie"
  },
  {
    id: "3397",
    word: "buchet"
  },
  {
    id: "3400",
    word: "nepoată"
  },
  {
    id: "3401",
    word: "simptom"
  },
  {
    id: "3402",
    word: "scenariu"
  },
  {
    id: "3403",
    word: "revoltă"
  },
  {
    id: "3404",
    word: "stea de mare"
  },
  {
    id: "3406",
    word: "plus"
  },
  {
    id: "3407",
    word: "vrabie"
  },
  {
    id: "3408",
    word: "ambasadă"
  },
  {
    id: "3409",
    word: "podium"
  },
  {
    id: "3410",
    word: "acuzație"
  },
  {
    id: "3411",
    word: "conac"
  },
  {
    id: "3414",
    word: "ceainic"
  },
  {
    id: "3415",
    word: "a evita"
  },
  {
    id: "3418",
    word: "a dispărea"
  },
  {
    id: "3420",
    word: "la etaj"
  },
  {
    id: "3421",
    word: "lavă"
  },
  {
    id: "3422",
    word: "inspirație"
  },
  {
    id: "3423",
    word: "a afla"
  },
  {
    id: "3425",
    word: "supermarket"
  },
  {
    id: "3426",
    word: "trofeu"
  },
  {
    id: "3427",
    word: "gelozie"
  },
  {
    id: "3429",
    word: "pasaj"
  },
  {
    id: "3431",
    word: "rămas bun"
  },
  {
    id: "3434",
    word: "astronaut"
  },
  {
    id: "3436",
    word: "vocabular"
  },
  {
    id: "3437",
    word: "recuperare"
  },
  {
    id: "3438",
    word: "loc de muncă part-time"
  },
  {
    id: "3439",
    word: "amuzant"
  },
  {
    id: "3440",
    word: "logo"
  },
  {
    id: "3441",
    word: "casier"
  },
  {
    id: "3442",
    word: "îmblânzit"
  },
  {
    id: "3443",
    word: "instalator"
  },
  {
    id: "3444",
    word: "a visa"
  },
  {
    id: "3445",
    word: "CV"
  },
  {
    id: "3446",
    word: "țigan"
  },
  {
    id: "3447",
    word: "imitație"
  },
  {
    id: "3448",
    word: "angajator"
  },
  {
    id: "3451",
    word: "flaut"
  },
  {
    id: "3452",
    word: "grec"
  },
  {
    id: "3453",
    word: "cabină de probă"
  },
  {
    id: "3455",
    word: "a fi de acord"
  },
  {
    id: "3456",
    word: "republică"
  },
  {
    id: "3457",
    word: "smarald"
  },
  {
    id: "3459",
    word: "mărturie"
  },
  {
    id: "3462",
    word: "context"
  },
  {
    id: "3463",
    word: "afacere"
  },
  {
    id: "3465",
    word: "mașină de pompieri"
  },
  {
    id: "3466",
    word: "lebădă"
  },
  {
    id: "3467",
    word: "ramă"
  },
  {
    id: "3468",
    word: "lentilă de contact"
  },
  {
    id: "3469",
    word: "semnificație"
  },
  {
    id: "3470",
    word: "trambulină"
  },
  {
    id: "3471",
    word: "metru pătrat"
  },
  {
    id: "3472",
    word: "pub"
  },
  {
    id: "3473",
    word: "dus-întors"
  },
  {
    id: "3474",
    word: "sponsor"
  },
  {
    id: "3476",
    word: "a se întoarce"
  },
  {
    id: "3477",
    word: "a închiria"
  },
  {
    id: "3478",
    word: "medalie"
  },
  {
    id: "3479",
    word: "percepție"
  },
  {
    id: "3481",
    word: "dicționar"
  },
  {
    id: "3482",
    word: "metaforă"
  },
  {
    id: "3483",
    word: "sărăcie"
  },
  {
    id: "3486",
    word: "lesă"
  },
  {
    id: "3488",
    word: "logodnic"
  },
  {
    id: "3489",
    word: "paste"
  },
  {
    id: "3490",
    word: "oțet"
  },
  {
    id: "3491",
    word: "carne de vită"
  },
  {
    id: "3492",
    word: "amar"
  },
  {
    id: "3494",
    word: "cocoș"
  },
  {
    id: "3495",
    word: "panteră"
  },
  {
    id: "3496",
    word: "nevăstuică"
  },
  {
    id: "3497",
    word: "zebră"
  },
  {
    id: "3498",
    word: "delfin"
  },
  {
    id: "3500",
    word: "cameră de oaspeți"
  }
];



// WEBPACK FOOTER //
// ./src/containers/Words/ro.js